import api from '~/services/api';

class EquipmentService {
  static getModels = (data) =>
    api
      .post(`/v1/catalog`, data)
      .then((res) => {
        // const ret = { data: res.data };
        // console.log('getModels.request => ', data);
        // console.log('getModels.response => ', res.data);
        const productLine = data?.evaporator?.productLine ?? data?.condensingUnit?.productLine;
        // console.log('productLine => ', productLine);
        const ret = res.data.filter((product) => (productLine !== undefined ? product.line === productLine : true));
        // console.log('getModels.return => ', ret);
        return ret;
      })
      .catch((error) => {
        throw error;
      });

  static getSKUs = async (data) => {
    const response = await api.post(`/v1/catalog/skus`, data);
    return response;
  };

  // static getOptionals = (type: string) => api.get(`/v1/catalog/optionals/${type}`);
  static getOptionals = (type: string, line: string): any => {
    let ret = null;

    if (type === 'evaporators')
      ret =
        EquipmentService.optionalsEvaporators[EquipmentService.optionalsEvaporators.findIndex((x) => x.linha === line)];
    if (type === 'condensingUnits')
      ret =
        EquipmentService.optionalsUnitCondensing[
          EquipmentService.optionalsUnitCondensing.findIndex((x) => x.linha === line)
        ];

    return { data: ret };
  };

  static getCompressor = (data) => [
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00054GD',
      Modelo: 'ESHX4B00054',
      Carcaça: '1',
      HP: '5',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '32',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '86',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '137',
      'MCC (A)': '31',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '462',
      'B (mm)': '75',
      'C (mm)': '306',
      'D (mm)': '306',
      'E (mm)': '316',
      Elet_Kp: '1.2',
      Elet_Qc: '0.3',
      'C-Volumetrico': '0.07',
      'N-Volumetrico': '1.8',
      'C-Isoentropico': '0.7',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00054GD',
      Modelo: 'ESHX4B00054',
      Carcaça: '1',
      HP: '5',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '32',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '87',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.1',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '80',
      'MCC (A)': '19',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '462',
      'B (mm)': '75',
      'C (mm)': '306',
      'D (mm)': '306',
      'E (mm)': '316',
      Elet_Kp: '1.2',
      Elet_Qc: '0.3',
      'C-Volumetrico': '0.07',
      'N-Volumetrico': '1.8',
      'C-Isoentropico': '0.7',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00054KD',
      Modelo: 'ESHX4B00054',
      Carcaça: '1',
      HP: '5',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '32',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '86',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '63',
      'MCC (A)': '15',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '74db(A)',
      'A (mm)': '462',
      'B (mm)': '75',
      'C (mm)': '306',
      'D (mm)': '306',
      'E (mm)': '316',
      Elet_Kp: '1.2',
      Elet_Qc: '0.3',
      'C-Volumetrico': '0.07',
      'N-Volumetrico': '1.8',
      'C-Isoentropico': '0.7',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00064GD',
      Modelo: 'ESHX4B00064',
      Carcaça: '1',
      HP: '6',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '39',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '91',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '182',
      'MCC (A)': '37',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '457',
      'B (mm)': '101',
      'C (mm)': '310',
      'D (mm)': '310',
      'E (mm)': '386',
      Elet_Kp: '1.1',
      Elet_Qc: '0.29',
      'C-Volumetrico': '0.045',
      'N-Volumetrico': '1.35',
      'C-Isoentropico': '0.71',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00064GD',
      Modelo: 'ESHX4B00064',
      Carcaça: '1',
      HP: '6',
      Aplicação: 'Baixa',
      Cilindros: '5',
      'Deslocamento 60Hz (m3h)': '39',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '91',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '105',
      'MCC (A)': '23',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '457',
      'B (mm)': '101',
      'C (mm)': '310',
      'D (mm)': '310',
      'E (mm)': '386',
      Elet_Kp: '1.1',
      Elet_Qc: '0.29',
      'C-Volumetrico': '0.045',
      'N-Volumetrico': '1.35',
      'C-Isoentropico': '0.71',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00064KD',
      Modelo: 'ESHX4B00064',
      Carcaça: '1',
      HP: '6',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '39',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '91',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '83',
      'MCC (A)': '18',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '74db(A)',
      'A (mm)': '457',
      'B (mm)': '101',
      'C (mm)': '310',
      'D (mm)': '310',
      'E (mm)': '386',
      Elet_Kp: '1.1',
      Elet_Qc: '0.29',
      'C-Volumetrico': '0.045',
      'N-Volumetrico': '1.35',
      'C-Isoentropico': '0.71',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00094GD',
      Modelo: 'ESHX4B00094',
      Carcaça: '2',
      HP: '9',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '49',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '134',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '182',
      'MCC (A)': '26',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '0.008',
      Elet_Qc: '0.09',
      'C-Volumetrico': '0.04159',
      'N-Volumetrico': '1.22',
      'C-Isoentropico': '0.71',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00094GD',
      Modelo: 'ESHX4B00094',
      Carcaça: '2',
      HP: '9',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '49',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '134',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '105',
      'MCC (A)': '23',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '0.008',
      Elet_Qc: '0.09',
      'C-Volumetrico': '0.04159',
      'N-Volumetrico': '1.22',
      'C-Isoentropico': '0.71',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00094KD',
      Modelo: 'ESHX4B00094',
      Carcaça: '2',
      HP: '9',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '49',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '134',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '81',
      'MCC (A)': '20',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '78db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '0.008',
      Elet_Qc: '0.09',
      'C-Volumetrico': '0.04159',
      'N-Volumetrico': '1.22',
      'C-Isoentropico': '0.71',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00124GD',
      Modelo: 'ESHX4B00124',
      Carcaça: '2',
      HP: '12',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '58',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '139',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '172',
      'MCC (A)': '42',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '78db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '1.1',
      Elet_Qc: '0.32',
      'C-Volumetrico': '0.1',
      'N-Volumetrico': '1.73',
      'C-Isoentropico': '0.71',
      'B-Isoentropico': '-0.02',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00124GD',
      Modelo: 'ESHX4B00124',
      Carcaça: '2',
      HP: '12',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '58',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '139',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '126',
      'MCC (A)': '29',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '78db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '1.1',
      Elet_Qc: '0.32',
      'C-Volumetrico': '0.1',
      'N-Volumetrico': '1.73',
      'C-Isoentropico': '0.71',
      'B-Isoentropico': '-0.02',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00124KD',
      Modelo: 'ESHX4B00124',
      Carcaça: '2',
      HP: '12',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '58',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '139',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '99',
      'MCC (A)': '23',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '78db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '1.1',
      Elet_Qc: '0.32',
      'C-Volumetrico': '0.1',
      'N-Volumetrico': '1.73',
      'C-Isoentropico': '0.71',
      'B-Isoentropico': '-0.02',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00144GD',
      Modelo: 'ESHX4B00144',
      Carcaça: '2',
      HP: '14',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '68',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '141',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '240',
      'MCC (A)': '53',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '80db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '0.8',
      Elet_Qc: '0.33',
      'C-Volumetrico': '0.065',
      'N-Volumetrico': '1.52',
      'C-Isoentropico': '0.74',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00144GD',
      Modelo: 'ESHX4B00144',
      Carcaça: '2',
      HP: '14',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '68',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '141',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '145',
      'MCC (A)': '34',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '80db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '0.8',
      Elet_Qc: '0.33',
      'C-Volumetrico': '0.065',
      'N-Volumetrico': '1.52',
      'C-Isoentropico': '0.74',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00144KD',
      Modelo: 'ESHX4B00144',
      Carcaça: '2',
      HP: '14',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '68',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '141',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '113',
      'MCC (A)': '27',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '80db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '0.8',
      Elet_Qc: '0.33',
      'C-Volumetrico': '0.065',
      'N-Volumetrico': '1.52',
      'C-Isoentropico': '0.74',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00184TP',
      Modelo: 'ESHX4B00184',
      Carcaça: '3',
      HP: '18',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '88',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '183',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 5 /8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.0',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '335',
      'MCC (A)': '78',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '81db(A)',
      'A (mm)': '688',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.4',
      Elet_Qc: '0.42',
      'C-Volumetrico': '0.05',
      'N-Volumetrico': '1.82',
      'C-Isoentropico': '0.66',
      'B-Isoentropico': '0.02',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00184JP',
      Modelo: 'ESHX4B00184',
      Carcaça: '3',
      HP: '18',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '88',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '183',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 5 /8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.0',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '202',
      'MCC (A)': '47',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '81db(A)',
      'A (mm)': '688',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.4',
      Elet_Qc: '0.42',
      'C-Volumetrico': '0.05',
      'N-Volumetrico': '1.82',
      'C-Isoentropico': '0.66',
      'B-Isoentropico': '0.02',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00184KP',
      Modelo: 'ESHX4B00184',
      Carcaça: '3',
      HP: '18',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '88',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '183',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 5 /8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.0',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '158',
      'MCC (A)': '37',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '81db(A)',
      'A (mm)': '688',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.4',
      Elet_Qc: '0.42',
      'C-Volumetrico': '0.05',
      'N-Volumetrico': '1.82',
      'C-Isoentropico': '0.66',
      'B-Isoentropico': '0.02',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00234TP',
      Modelo: 'ESHX4B00234',
      Carcaça: '3',
      HP: '23',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '101',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '192',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '335',
      'MCC (A)': '93',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '85db(A)',
      'A (mm)': '706',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.4',
      Elet_Qc: '0.42',
      'C-Volumetrico': '0.008',
      'N-Volumetrico': '0.76',
      'C-Isoentropico': '0.58',
      'B-Isoentropico': '0.1',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00234JP',
      Modelo: 'ESHX4B00234',
      Carcaça: '3',
      HP: '23',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '101',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '192',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '202',
      'MCC (A)': '56',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '85db(A)',
      'A (mm)': '706',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.4',
      Elet_Qc: '0.42',
      'C-Volumetrico': '0.008',
      'N-Volumetrico': '0.76',
      'C-Isoentropico': '0.58',
      'B-Isoentropico': '0.1',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00234KP',
      Modelo: 'ESHX4B00234',
      Carcaça: '3',
      HP: '23',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '101',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '192',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '158',
      'MCC (A)': '44',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '85db(A)',
      'A (mm)': '706',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.4',
      Elet_Qc: '0.42',
      'C-Volumetrico': '0.008',
      'N-Volumetrico': '0.76',
      'C-Isoentropico': '0.58',
      'B-Isoentropico': '0.1',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00284TP',
      Modelo: 'ESHX4B00284',
      Carcaça: '3',
      HP: '28',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '121',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '196',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '495',
      'MCC (A)': '115',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '86db(A)',
      'A (mm)': '737',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.17',
      Elet_Qc: '1.05',
      'C-Volumetrico': '0.015',
      'N-Volumetrico': '1.2',
      'C-Isoentropico': '0.58',
      'B-Isoentropico': '0.1',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00284JP',
      Modelo: 'ESHX4B00284',
      Carcaça: '3',
      HP: '28',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '121',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '196',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '296',
      'MCC (A)': '67',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '86db(A)',
      'A (mm)': '737',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.17',
      Elet_Qc: '1.05',
      'C-Volumetrico': '0.015',
      'N-Volumetrico': '1.2',
      'C-Isoentropico': '0.58',
      'B-Isoentropico': '0.1',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00284KP',
      Modelo: 'ESHX4B00284',
      Carcaça: '3',
      HP: '28',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '121',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '196',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '233',
      'MCC (A)': '53',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '86db(A)',
      'A (mm)': '737',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.17',
      Elet_Qc: '1.05',
      'C-Volumetrico': '0.015',
      'N-Volumetrico': '1.2',
      'C-Isoentropico': '0.58',
      'B-Isoentropico': '0.1',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6B00344TP',
      Modelo: 'ESHX6B00344',
      Carcaça: '4',
      HP: '34',
      Aplicação: 'Baixa',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '153',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '228',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 3/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '495',
      'MCC (A)': '138',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '89db(A)',
      'A (mm)': '767',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.032',
      Elet_Qc: '1.3',
      'C-Volumetrico': '0.05',
      'N-Volumetrico': '1.9',
      'C-Isoentropico': '0.62',
      'B-Isoentropico': '0.04',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6B00344JP',
      Modelo: 'ESHX6B00344',
      Carcaça: '4',
      HP: '34',
      Aplicação: 'Baixa',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '153',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '228',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 3/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '296',
      'MCC (A)': '84',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '89db(A)',
      'A (mm)': '767',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.032',
      Elet_Qc: '1.3',
      'C-Volumetrico': '0.05',
      'N-Volumetrico': '1.9',
      'C-Isoentropico': '0.62',
      'B-Isoentropico': '0.04',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6B00344KP',
      Modelo: 'ESHX6B00344',
      Carcaça: '4',
      HP: '34',
      Aplicação: 'Baixa',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '153',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '228',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 3/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '233',
      'MCC (A)': '66',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '89db(A)',
      'A (mm)': '767',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.032',
      Elet_Qc: '1.3',
      'C-Volumetrico': '0.05',
      'N-Volumetrico': '1.9',
      'C-Isoentropico': '0.62',
      'B-Isoentropico': '0.04',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6B00444TP',
      Modelo: 'ESHX6B00444',
      Carcaça: '5',
      HP: '44',
      Aplicação: 'Baixa',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '183',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '238',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 5/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '765',
      'MCC (A)': '176',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '90db(A)',
      'A (mm)': '790',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.032',
      Elet_Qc: '2.2',
      'C-Volumetrico': '0.034',
      'N-Volumetrico': '1.4',
      'C-Isoentropico': '0.63',
      'B-Isoentropico': '0.01',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6B00444JP',
      Modelo: 'ESHX6B00444',
      Carcaça: '5',
      HP: '44',
      Aplicação: 'Baixa',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '183',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '238',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 5/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '460',
      'MCC (A)': '106',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '90db(A)',
      'A (mm)': '790',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.032',
      Elet_Qc: '2.2',
      'C-Volumetrico': '0.034',
      'N-Volumetrico': '1.4',
      'C-Isoentropico': '0.63',
      'B-Isoentropico': '0.01',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6B00444KP',
      Modelo: 'ESHX6B00444',
      Carcaça: '5',
      HP: '44',
      Aplicação: 'Baixa',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '183',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '238',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 5/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '362',
      'MCC (A)': '84',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '90db(A)',
      'A (mm)': '790',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.032',
      Elet_Qc: '2.2',
      'C-Volumetrico': '0.034',
      'N-Volumetrico': '1.4',
      'C-Isoentropico': '0.63',
      'B-Isoentropico': '0.01',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0054GD',
      Modelo: 'ESHX4MB0054',
      Carcaça: '1',
      HP: '5',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '21',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '95',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '7/8"',
      'Descarga (in)': '5/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '140',
      'MCC (A)': '23',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '432',
      'B (mm)': '75',
      'C (mm)': '306',
      'D (mm)': '306',
      'E (mm)': '316',
      Elet_Kp: '1.2',
      Elet_Qc: '0.3',
      'C-Volumetrico': '0.06',
      'N-Volumetrico': '1.95',
      'C-Isoentropico': '0.73',
      'B-Isoentropico': '-0.076',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0054GD',
      Modelo: 'ESHX4MB0054',
      Carcaça: '1',
      HP: '5',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '21',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '95',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '7/8"',
      'Descarga (in)': '5/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '80',
      'MCC (A)': '14',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '432',
      'B (mm)': '75',
      'C (mm)': '306',
      'D (mm)': '306',
      'E (mm)': '316',
      Elet_Kp: '1.2',
      Elet_Qc: '0.3',
      'C-Volumetrico': '0.06',
      'N-Volumetrico': '1.95',
      'C-Isoentropico': '0.73',
      'B-Isoentropico': '-0.076',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0054KD',
      Modelo: 'ESHX4MB0054',
      Carcaça: '1',
      HP: '5',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '21',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '95',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '7/8"',
      'Descarga (in)': '5/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '63',
      'MCC (A)': '11',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '74db(A)',
      'A (mm)': '432',
      'B (mm)': '75',
      'C (mm)': '306',
      'D (mm)': '306',
      'E (mm)': '316',
      Elet_Kp: '1.2',
      Elet_Qc: '0.3',
      'C-Volumetrico': '0.06',
      'N-Volumetrico': '1.95',
      'C-Isoentropico': '0.73',
      'B-Isoentropico': '-0.076',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0074GD',
      Modelo: 'ESHX4MB0074',
      Carcaça: '1',
      HP: '7',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '32',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '100',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '182',
      'MCC (A)': '35',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '457',
      'B (mm)': '101',
      'C (mm)': '310',
      'D (mm)': '310',
      'E (mm)': '386',
      Elet_Kp: '1.15',
      Elet_Qc: '0.35',
      'C-Volumetrico': '0.039',
      'N-Volumetrico': '1.4',
      'C-Isoentropico': '0.67',
      'B-Isoentropico': '0',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0074GD',
      Modelo: 'ESHX4MB0074',
      Carcaça: '1',
      HP: '7',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '32',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '100',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '105',
      'MCC (A)': '21',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '457',
      'B (mm)': '101',
      'C (mm)': '310',
      'D (mm)': '310',
      'E (mm)': '386',
      Elet_Kp: '1.15',
      Elet_Qc: '0.35',
      'C-Volumetrico': '0.039',
      'N-Volumetrico': '1.4',
      'C-Isoentropico': '0.67',
      'B-Isoentropico': '0',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0074KD',
      Modelo: 'ESHX4MB0074',
      Carcaça: '1',
      HP: '7',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '32',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '100',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '83',
      'MCC (A)': '17',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '74db(A)',
      'A (mm)': '457',
      'B (mm)': '101',
      'C (mm)': '310',
      'D (mm)': '310',
      'E (mm)': '386',
      Elet_Kp: '1.15',
      Elet_Qc: '0.35',
      'C-Volumetrico': '0.039',
      'N-Volumetrico': '1.4',
      'C-Isoentropico': '0.67',
      'B-Isoentropico': '0',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0094GD',
      Modelo: 'ESHX4MB0094',
      Carcaça: '1',
      HP: '9',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '39',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '99',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '182',
      'MCC (A)': '43',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '457',
      'B (mm)': '101',
      'C (mm)': '310',
      'D (mm)': '310',
      'E (mm)': '386',
      Elet_Kp: '1.12',
      Elet_Qc: '0.38',
      'C-Volumetrico': '0.025',
      'N-Volumetrico': '1.09',
      'C-Isoentropico': '0.68',
      'B-Isoentropico': '-0.03',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0094GD',
      Modelo: 'ESHX4MB0094',
      Carcaça: '1',
      HP: '9',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '39',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '99',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '105',
      'MCC (A)': '26',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '457',
      'B (mm)': '101',
      'C (mm)': '310',
      'D (mm)': '310',
      'E (mm)': '386',
      Elet_Kp: '1.12',
      Elet_Qc: '0.38',
      'C-Volumetrico': '0.025',
      'N-Volumetrico': '1.09',
      'C-Isoentropico': '0.68',
      'B-Isoentropico': '-0.03',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0094KD',
      Modelo: 'ESHX4MB0094',
      Carcaça: '1',
      HP: '9',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '39',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '99',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '83',
      'MCC (A)': '21',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '74db(A)',
      'A (mm)': '457',
      'B (mm)': '101',
      'C (mm)': '310',
      'D (mm)': '310',
      'E (mm)': '386',
      Elet_Kp: '1.12',
      Elet_Qc: '0.38',
      'C-Volumetrico': '0.025',
      'N-Volumetrico': '1.09',
      'C-Isoentropico': '0.68',
      'B-Isoentropico': '-0.03',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0124GD',
      Modelo: 'ESHX4MB0124',
      Carcaça: '2',
      HP: '12',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '49',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '147',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '240',
      'MCC (A)': '53',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '1.15',
      Elet_Qc: '0.42',
      'C-Volumetrico': '0.035',
      'N-Volumetrico': '1.35',
      'C-Isoentropico': '0.68',
      'B-Isoentropico': '0',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0124GD',
      Modelo: 'ESHX4MB0124',
      Carcaça: '2',
      HP: '12',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '49',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '147',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '145',
      'MCC (A)': '32',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '76db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '1.15',
      Elet_Qc: '0.42',
      'C-Volumetrico': '0.035',
      'N-Volumetrico': '1.35',
      'C-Isoentropico': '0.68',
      'B-Isoentropico': '0',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0124KD',
      Modelo: 'ESHX4MB0124',
      Carcaça: '2',
      HP: '12',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '49',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '147',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 5/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '113',
      'MCC (A)': '25',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '78db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '1.15',
      Elet_Qc: '0.42',
      'C-Volumetrico': '0.035',
      'N-Volumetrico': '1.35',
      'C-Isoentropico': '0.68',
      'B-Isoentropico': '0',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0154TP',
      Modelo: 'ESHX4MB0154',
      Carcaça: '2',
      HP: '15',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '58',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '153',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 5/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '280',
      'MCC (A)': '60',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '78db(A)',
      'A (mm)': '657',
      'B (mm)': '581',
      'C (mm)': '173',
      'D (mm)': '173',
      'E (mm)': '160',
      Elet_Kp: '0.085',
      Elet_Qc: '0.55',
      'C-Volumetrico': '0.088',
      'N-Volumetrico': '1.77',
      'C-Isoentropico': '0.65',
      'B-Isoentropico': '-0.01',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0154JP',
      Modelo: 'ESHX4MB0154',
      Carcaça: '2',
      HP: '15',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '58',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '153',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 5/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '168',
      'MCC (A)': '36',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '78db(A)',
      'A (mm)': '657',
      'B (mm)': '581',
      'C (mm)': '173',
      'D (mm)': '173',
      'E (mm)': '160',
      Elet_Kp: '0.085',
      Elet_Qc: '0.55',
      'C-Volumetrico': '0.088',
      'N-Volumetrico': '1.77',
      'C-Isoentropico': '0.65',
      'B-Isoentropico': '-0.01',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0154KP',
      Modelo: 'ESHX4MB0154',
      Carcaça: '2',
      HP: '15',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '58',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '153',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 5/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '132',
      'MCC (A)': '29',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '78db(A)',
      'A (mm)': '657',
      'B (mm)': '581',
      'C (mm)': '173',
      'D (mm)': '173',
      'E (mm)': '160',
      Elet_Kp: '0.085',
      Elet_Qc: '0.55',
      'C-Volumetrico': '0.088',
      'N-Volumetrico': '1.77',
      'C-Isoentropico': '0.65',
      'B-Isoentropico': '-0.01',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0204TP',
      Modelo: 'ESHX4MB0204',
      Carcaça: '2',
      HP: '20',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '68',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '157',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 5/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '335',
      'MCC (A)': '70',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '80db(A)',
      'A (mm)': '657',
      'B (mm)': '581',
      'C (mm)': '173',
      'D (mm)': '173',
      'E (mm)': '160',
      Elet_Kp: '0.085',
      Elet_Qc: '0.68',
      'C-Volumetrico': '0.035',
      'N-Volumetrico': '1.21',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '-0.03',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0204JP',
      Modelo: 'ESHX4MB0204',
      Carcaça: '2',
      HP: '20',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '68',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '157',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 5/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '202',
      'MCC (A)': '43',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '80db(A)',
      'A (mm)': '657',
      'B (mm)': '581',
      'C (mm)': '173',
      'D (mm)': '173',
      'E (mm)': '160',
      Elet_Kp: '0.085',
      Elet_Qc: '0.68',
      'C-Volumetrico': '0.035',
      'N-Volumetrico': '1.21',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '-0.03',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0204KP',
      Modelo: 'ESHX4MB0204',
      Carcaça: '2',
      HP: '20',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '68',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '157',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '158',
      'MCC (A)': '33',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '80db(A)',
      'A (mm)': '657',
      'B (mm)': '581',
      'C (mm)': '173',
      'D (mm)': '173',
      'E (mm)': '160',
      Elet_Kp: '0.085',
      Elet_Qc: '0.68',
      'C-Volumetrico': '0.035',
      'N-Volumetrico': '1.21',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '-0.03',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0254TP',
      Modelo: 'ESHX4MB0254',
      Carcaça: '3',
      HP: '25',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '88',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '207',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.0',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '445',
      'MCC (A)': '96',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '81db(A)',
      'A (mm)': '688',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.05',
      Elet_Qc: '0.91',
      'C-Volumetrico': '0.055',
      'N-Volumetrico': '1.73',
      'C-Isoentropico': '0.59',
      'B-Isoentropico': '0.087',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0254JP',
      Modelo: 'ESHX4MB0254',
      Carcaça: '3',
      HP: '25',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '88',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '207',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.0',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '270',
      'MCC (A)': '56',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '81db(A)',
      'A (mm)': '688',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.05',
      Elet_Qc: '0.91',
      'C-Volumetrico': '0.055',
      'N-Volumetrico': '1.73',
      'C-Isoentropico': '0.59',
      'B-Isoentropico': '0.087',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0254KP',
      Modelo: 'ESHX4MB0254',
      Carcaça: '3',
      HP: '25',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '88',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '207',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.0',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '211',
      'MCC (A)': '44',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '81db(A)',
      'A (mm)': '688',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.05',
      Elet_Qc: '0.91',
      'C-Volumetrico': '0.055',
      'N-Volumetrico': '1.73',
      'C-Isoentropico': '0.59',
      'B-Isoentropico': '0.087',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0304TP',
      Modelo: 'ESHX4MB0304',
      Carcaça: '3',
      HP: '30',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '101',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '209',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '495',
      'MCC (A)': '108',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '86db(A)',
      'A (mm)': '737',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.075',
      Elet_Qc: '1.3',
      'C-Volumetrico': '0.04',
      'N-Volumetrico': '1.4',
      'C-Isoentropico': '0.68',
      'B-Isoentropico': '0.02',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0304JP',
      Modelo: 'ESHX4MB0304',
      Carcaça: '3',
      HP: '30',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '101',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '209',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '296',
      'MCC (A)': '65',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '86db(A)',
      'A (mm)': '737',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.075',
      Elet_Qc: '1.3',
      'C-Volumetrico': '0.04',
      'N-Volumetrico': '1.4',
      'C-Isoentropico': '0.68',
      'B-Isoentropico': '0.02',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0304KP',
      Modelo: 'ESHX4MB0304',
      Carcaça: '3',
      HP: '30',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '101',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '209',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '233',
      'MCC (A)': '52',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '86db(A)',
      'A (mm)': '737',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.075',
      Elet_Qc: '1.3',
      'C-Volumetrico': '0.04',
      'N-Volumetrico': '1.4',
      'C-Isoentropico': '0.68',
      'B-Isoentropico': '0.02',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0354TP',
      Modelo: 'ESHX4MB0354',
      Carcaça: '3',
      HP: '35',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '121',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '207',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '495',
      'MCC (A)': '132',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '86db(A)',
      'A (mm)': '737',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.065',
      Elet_Qc: '1.6',
      'C-Volumetrico': '0.04',
      'N-Volumetrico': '1.5',
      'C-Isoentropico': '0.61',
      'B-Isoentropico': '0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0354JP',
      Modelo: 'ESHX4MB0354',
      Carcaça: '3',
      HP: '35',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '121',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '207',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '296',
      'MCC (A)': '79',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '86db(A)',
      'A (mm)': '737',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.065',
      Elet_Qc: '1.6',
      'C-Volumetrico': '0.04',
      'N-Volumetrico': '1.5',
      'C-Isoentropico': '0.61',
      'B-Isoentropico': '0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0354KP',
      Modelo: 'ESHX4MB0354',
      Carcaça: '3',
      HP: '35',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '121',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '207',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '233',
      'MCC (A)': '62',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '86db(A)',
      'A (mm)': '737',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.065',
      Elet_Qc: '1.6',
      'C-Volumetrico': '0.04',
      'N-Volumetrico': '1.5',
      'C-Isoentropico': '0.61',
      'B-Isoentropico': '0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6MB0404TP',
      Modelo: 'ESHX6MB0404',
      Carcaça: '4',
      HP: '40',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '153',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '240',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 3/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '765',
      'MCC (A)': '156',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '89db(A)',
      'A (mm)': '798',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '-0.07',
      Elet_Qc: '2',
      'C-Volumetrico': '0.08',
      'N-Volumetrico': '1.81',
      'C-Isoentropico': '0.66',
      'B-Isoentropico': '-0.03',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6MB0404JP',
      Modelo: 'ESHX6MB0404',
      Carcaça: '4',
      HP: '40',
      Aplicação: 'Media',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '153',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '240',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 3/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '460',
      'MCC (A)': '94',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '89db(A)',
      'A (mm)': '798',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '-0.07',
      Elet_Qc: '2',
      'C-Volumetrico': '0.08',
      'N-Volumetrico': '1.81',
      'C-Isoentropico': '0.66',
      'B-Isoentropico': '-0.03',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6MB0404KP',
      Modelo: 'ESHX6MB0404',
      Carcaça: '4',
      HP: '40',
      Aplicação: 'Media',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '153',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '240',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 3/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '362',
      'MCC (A)': '74',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '89db(A)',
      'A (mm)': '798',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '-0.07',
      Elet_Qc: '2',
      'C-Volumetrico': '0.08',
      'N-Volumetrico': '1.81',
      'C-Isoentropico': '0.66',
      'B-Isoentropico': '-0.03',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6MB0504TP',
      Modelo: 'ESHX6MB0504',
      Carcaça: '5',
      HP: '50',
      Aplicação: 'Media',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '183',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '246',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 5/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '851',
      'MCC (A)': '203',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '90db(A)',
      'A (mm)': '790',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.05',
      Elet_Qc: '3.2',
      'C-Volumetrico': '0.06',
      'N-Volumetrico': '1.6',
      'C-Isoentropico': '0.63',
      'B-Isoentropico': '0',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6MB0504JP',
      Modelo: 'ESHX6MB0504',
      Carcaça: '5',
      HP: '50',
      Aplicação: 'Media',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '183',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '246',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 5/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '510',
      'MCC (A)': '122',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '90db(A)',
      'A (mm)': '790',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.05',
      Elet_Qc: '3.2',
      'C-Volumetrico': '0.06',
      'N-Volumetrico': '1.6',
      'C-Isoentropico': '0.63',
      'B-Isoentropico': '0',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6MB0504KP',
      Modelo: 'ESHX6MB0504',
      Carcaça: '5',
      HP: '50',
      Aplicação: 'Media',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '183',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '246',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 5/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '440',
      Fase: '3F',
      Frequencia: '60',
      'RLA (A)': '404',
      'MCC (A)': '96',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '90db(A)',
      'A (mm)': '790',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.05',
      Elet_Qc: '3.2',
      'C-Volumetrico': '0.06',
      'N-Volumetrico': '1.6',
      'C-Isoentropico': '0.63',
      'B-Isoentropico': '0',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00054KD',
      Modelo: 'ESHX4B00054',
      Carcaça: '1',
      HP: '5',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '27',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '86',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '63',
      'MCC (A)': '15',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '74db(A)',
      'A (mm)': '462',
      'B (mm)': '75',
      'C (mm)': '306',
      'D (mm)': '306',
      'E (mm)': '316',
      Elet_Kp: '1.2',
      Elet_Qc: '0.3',
      'C-Volumetrico': '0.07',
      'N-Volumetrico': '1.8',
      'C-Isoentropico': '0.7',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00064KD',
      Modelo: 'ESHX4B00064',
      Carcaça: '1',
      HP: '6',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '33',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '91',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '83',
      'MCC (A)': '18',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '74db(A)',
      'A (mm)': '457',
      'B (mm)': '101',
      'C (mm)': '310',
      'D (mm)': '310',
      'E (mm)': '386',
      Elet_Kp: '1.1',
      Elet_Qc: '0.29',
      'C-Volumetrico': '0.045',
      'N-Volumetrico': '1.35',
      'C-Isoentropico': '0.71',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00094KD',
      Modelo: 'ESHX4B00094',
      Carcaça: '2',
      HP: '9',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '41',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '134',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '81',
      'MCC (A)': '20',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '78db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '0.008',
      Elet_Qc: '0.09',
      'C-Volumetrico': '0.04159',
      'N-Volumetrico': '1.22',
      'C-Isoentropico': '0.71',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00124KD',
      Modelo: 'ESHX4B00124',
      Carcaça: '2',
      HP: '12',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '48',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '139',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '99',
      'MCC (A)': '23',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '78db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '1.1',
      Elet_Qc: '0.32',
      'C-Volumetrico': '0.1',
      'N-Volumetrico': '1.73',
      'C-Isoentropico': '0.71',
      'B-Isoentropico': '-0.02',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00144KD',
      Modelo: 'ESHX4B00144',
      Carcaça: '2',
      HP: '14',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '56',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '141',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '113',
      'MCC (A)': '27',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '80db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '0.8',
      Elet_Qc: '0.33',
      'C-Volumetrico': '0.065',
      'N-Volumetrico': '1.52',
      'C-Isoentropico': '0.74',
      'B-Isoentropico': '-0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0054KD',
      Modelo: 'ESHX4MB0054',
      Carcaça: '1',
      HP: '5',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '18',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '95',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '7/8"',
      'Descarga (in)': '5/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '63',
      'MCC (A)': '11',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '74db(A)',
      'A (mm)': '432',
      'B (mm)': '75',
      'C (mm)': '306',
      'D (mm)': '306',
      'E (mm)': '316',
      Elet_Kp: '1.2',
      Elet_Qc: '0.3',
      'C-Volumetrico': '0.06',
      'N-Volumetrico': '1.95',
      'C-Isoentropico': '0.73',
      'B-Isoentropico': '-0.076',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0074KD',
      Modelo: 'ESHX4MB0074',
      Carcaça: '1',
      HP: '7',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '27',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '100',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 1/8"',
      'Descarga (in)': '7/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '93',
      'MCC (A)': '17',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '74db(A)',
      'A (mm)': '457',
      'B (mm)': '101',
      'C (mm)': '310',
      'D (mm)': '310',
      'E (mm)': '386',
      Elet_Kp: '1.15',
      Elet_Qc: '0.35',
      'C-Volumetrico': '0.039',
      'N-Volumetrico': '1.4',
      'C-Isoentropico': '0.67',
      'B-Isoentropico': '0',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0094KD',
      Modelo: 'ESHX4MB0094',
      Carcaça: '1',
      HP: '9',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '33',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '99',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 3/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.0',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '93',
      'MCC (A)': '21',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '74db(A)',
      'A (mm)': '457',
      'B (mm)': '101',
      'C (mm)': '310',
      'D (mm)': '310',
      'E (mm)': '386',
      Elet_Kp: '1.12',
      Elet_Qc: '0.38',
      'C-Volumetrico': '0.025',
      'N-Volumetrico': '1.09',
      'C-Isoentropico': '0.68',
      'B-Isoentropico': '-0.03',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0124KD',
      Modelo: 'ESHX4MB0124',
      Carcaça: '2',
      HP: '12',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '41',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '147',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 5/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '113',
      'MCC (A)': '25',
      'Fechamento elétrico': 'Partida Direta D-Y',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '78db(A)',
      'A (mm)': '632',
      'B (mm)': '557',
      'C (mm)': '161',
      'D (mm)': '161',
      'E (mm)': '140',
      Elet_Kp: '1.15',
      Elet_Qc: '0.42',
      'C-Volumetrico': '0.035',
      'N-Volumetrico': '1.35',
      'C-Isoentropico': '0.68',
      'B-Isoentropico': '0',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00184KP',
      Modelo: 'ESHX4B00184',
      Carcaça: '3',
      HP: '15',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '71',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '183',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 5 /8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.0',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '158',
      'MCC (A)': '37',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '81db(A)',
      'A (mm)': '688',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.4',
      Elet_Qc: '0.42',
      'C-Volumetrico': '0.05',
      'N-Volumetrico': '1.82',
      'C-Isoentropico': '0.66',
      'B-Isoentropico': '0.02',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00234KP',
      Modelo: 'ESHX4B00234',
      Carcaça: '3',
      HP: '20',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '86',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '192',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '158',
      'MCC (A)': '44',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '85db(A)',
      'A (mm)': '706',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.4',
      Elet_Qc: '0.42',
      'C-Volumetrico': '0.008',
      'N-Volumetrico': '0.76',
      'C-Isoentropico': '0.58',
      'B-Isoentropico': '0.1',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4B00284KP',
      Modelo: 'ESHX4B00284',
      Carcaça: '3',
      HP: '25',
      Aplicação: 'Baixa',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '103',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '196',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '233',
      'MCC (A)': '53',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '86db(A)',
      'A (mm)': '737',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.17',
      Elet_Qc: '1.05',
      'C-Volumetrico': '0.015',
      'N-Volumetrico': '1.2',
      'C-Isoentropico': '0.58',
      'B-Isoentropico': '0.1',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6B00344KP',
      Modelo: 'ESHX6B00344',
      Carcaça: '4',
      HP: '30',
      Aplicação: 'Baixa',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '129',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '228',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 3/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '233',
      'MCC (A)': '66',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '89db(A)',
      'A (mm)': '767',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.032',
      Elet_Qc: '1.3',
      'C-Volumetrico': '0.05',
      'N-Volumetrico': '1.9',
      'C-Isoentropico': '0.62',
      'B-Isoentropico': '0.04',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6B00444KP',
      Modelo: 'ESHX6B00444',
      Carcaça: '5',
      HP: '40',
      Aplicação: 'Baixa',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '154',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '238',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 5/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '362',
      'MCC (A)': '84',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '90db(A)',
      'A (mm)': '790',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.032',
      Elet_Qc: '2.2',
      'C-Volumetrico': '0.034',
      'N-Volumetrico': '1.4',
      'C-Isoentropico': '0.63',
      'B-Isoentropico': '0.01',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0154KP',
      Modelo: 'ESHX4MB0154',
      Carcaça: '2',
      HP: '15',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '48',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '153',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '1 5/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '132',
      'MCC (A)': '29',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '78db(A)',
      'A (mm)': '657',
      'B (mm)': '581',
      'C (mm)': '173',
      'D (mm)': '173',
      'E (mm)': '160',
      Elet_Kp: '0.085',
      Elet_Qc: '0.55',
      'C-Volumetrico': '0.088',
      'N-Volumetrico': '1.77',
      'C-Isoentropico': '0.65',
      'B-Isoentropico': '-0.01',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0204KP',
      Modelo: 'ESHX4MB0204',
      Carcaça: '2',
      HP: '20',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '56',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '157',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '2.6',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '158',
      'MCC (A)': '33',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '80db(A)',
      'A (mm)': '657',
      'B (mm)': '581',
      'C (mm)': '173',
      'D (mm)': '173',
      'E (mm)': '160',
      Elet_Kp: '0.085',
      Elet_Qc: '0.68',
      'C-Volumetrico': '0.035',
      'N-Volumetrico': '1.21',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '-0.03',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0254KP',
      Modelo: 'ESHX4MB0254',
      Carcaça: '3',
      HP: '25',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '71',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '207',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.0',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '211',
      'MCC (A)': '44',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '81db(A)',
      'A (mm)': '688',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.05',
      Elet_Qc: '0.91',
      'C-Volumetrico': '0.055',
      'N-Volumetrico': '1.73',
      'C-Isoentropico': '0.59',
      'B-Isoentropico': '0.087',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0304KP',
      Modelo: 'ESHX4MB0304',
      Carcaça: '3',
      HP: '30',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '86',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '209',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '233',
      'MCC (A)': '52',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '86db(A)',
      'A (mm)': '737',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.075',
      Elet_Qc: '1.3',
      'C-Volumetrico': '0.04',
      'N-Volumetrico': '1.4',
      'C-Isoentropico': '0.68',
      'B-Isoentropico': '0.02',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX4MB0354KP',
      Modelo: 'ESHX4MB0354',
      Carcaça: '3',
      HP: '35',
      Aplicação: 'Media',
      Cilindros: '4',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '103',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '207',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 1/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '233',
      'MCC (A)': '62',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '86db(A)',
      'A (mm)': '737',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.065',
      Elet_Qc: '1.6',
      'C-Volumetrico': '0.04',
      'N-Volumetrico': '1.5',
      'C-Isoentropico': '0.61',
      'B-Isoentropico': '0.05',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6MB0404KP',
      Modelo: 'ESHX6MB0404',
      Carcaça: '4',
      HP: '40',
      Aplicação: 'Media',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '129',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '240',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 3/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '362',
      'MCC (A)': '74',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '89db(A)',
      'A (mm)': '798',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '-0.07',
      Elet_Qc: '2',
      'C-Volumetrico': '0.08',
      'N-Volumetrico': '1.81',
      'C-Isoentropico': '0.66',
      'B-Isoentropico': '-0.03',
    },
    {
      Marca: 'ESH',
      Tipo: 'Semi-Hermético',
      Código: 'ESHX6MB0504KP',
      Modelo: 'ESHX6MB0504',
      Carcaça: '5',
      HP: '50',
      Aplicação: 'Media',
      Cilindros: '6',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '154',
      Refrigerante: 'R404A / R507A / R407A / R134A',
      Peso: '246',
      'Pressão Maxima (LP)': '0.5bar',
      'Pressão Maxima (HP)': '26bar',
      'Sucção (in)': '2 1/8"',
      'Descarga (in)': '1 5/8"',
      Oleo: 'PE',
      'Carga de oleo': '4.8',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'RLA (A)': '404',
      'MCC (A)': '96',
      'Fechamento elétrico': 'Partida Dividida PW',
      IP: 'IP-54',
      'Controle de Capacidade ': 'ref00000000000000 (OPCIONAL)',
      'Resistencia de Carter': 'ref111111111111',
      'Nivel de ruido': '90db(A)',
      'A (mm)': '790',
      'B (mm)': '-',
      'C (mm)': '-',
      'D (mm)': '-',
      'E (mm)': '-',
      Elet_Kp: '0.05',
      Elet_Qc: '3.2',
      'C-Volumetrico': '0.06',
      'N-Volumetrico': '1.6',
      'C-Isoentropico': '0.63',
      'B-Isoentropico': '0',
    },
  ];

  static getCompressorHermetico = (data) => [
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM24000J',
      Modelo: 'ECM24000J',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '9.1080000000000005',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '30.1',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '26',
      'MCC (A)': '5.2',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM24000T',
      Modelo: 'ECM24000T',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '9.1080000000000005',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '30.1',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '46',
      'MCC (A)': '10.1',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM30000J',
      Modelo: 'ECM30000J',
      Carcaça: '1',
      HP: '2.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '10.763999999999999',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '32.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '33',
      'MCC (A)': '6.5',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM30000T',
      Modelo: 'ECM30000T',
      Carcaça: '1',
      HP: '2.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '10.763999999999999',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '32.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '65',
      'MCC (A)': '14.5',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM37000J',
      Modelo: 'ECM37000J',
      Carcaça: '1',
      HP: '3',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '12.978899999999999',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '33.4',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '40',
      'MCC (A)': '6.8',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.06',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM37000T',
      Modelo: 'ECM37000T',
      Carcaça: '1',
      HP: '3',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '12.978899999999999',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '33.4',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '86',
      'MCC (A)': '14.8',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.06',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM42000J',
      Modelo: 'ECM42000J',
      Carcaça: '1',
      HP: '3.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '15.359400000000001',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '33.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '42',
      'MCC (A)': '7.7',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM42000T',
      Modelo: 'ECM42000T',
      Carcaça: '1',
      HP: '3.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '15.359400000000001',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '33.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '88',
      'MCC (A)': '17',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM46000J',
      Modelo: 'ECM46000J',
      Carcaça: '2',
      HP: '3.3/4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '18.671399999999998',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '36.9',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '54',
      'MCC (A)': '9',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.51',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM46000T',
      Modelo: 'ECM46000T',
      Carcaça: '2',
      HP: '3.3/4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '18.671399999999998',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '36.9',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '96',
      'MCC (A)': '19.2',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.51',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM53000J',
      Modelo: 'ECM53000J',
      Carcaça: '2',
      HP: '4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '20.844899999999999',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '47.2',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '56',
      'MCC (A)': '11.7',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.43',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM53000T',
      Modelo: 'ECM53000T',
      Carcaça: '2',
      HP: '4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '20.844899999999999',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '47.2',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '108',
      'MCC (A)': '24.5',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.43',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM61000J',
      Modelo: 'ECM61000J',
      Carcaça: '2',
      HP: '5',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '23.287500000000001',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '47.3',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '59',
      'MCC (A)': '12.5',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.24',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM61000T',
      Modelo: 'ECM61000T',
      Carcaça: '2',
      HP: '5',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '23.287500000000001',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '47.3',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '128',
      'MCC (A)': '29',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.24',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM68000J',
      Modelo: 'ECM68000J',
      Carcaça: '2',
      HP: '5.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '25.750800000000002',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '48.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '62',
      'MCC (A)': '15.5',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.1',
      Elet_Qc: '0.34',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.47',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM68000T',
      Modelo: 'ECM68000T',
      Carcaça: '2',
      HP: '5.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '25.750800000000002',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '48.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '146',
      'MCC (A)': '31',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.1',
      Elet_Qc: '0.34',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.47',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM72000J',
      Modelo: 'ECM72000J',
      Carcaça: '2',
      HP: '6',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '27.903600000000004',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '49.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '64',
      'MCC (A)': '17',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '1.96',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.46',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM72000T',
      Modelo: 'ECM72000T',
      Carcaça: '2',
      HP: '6',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '27.903600000000004',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R22',
      Peso: '49.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '162',
      'MCC (A)': '36',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '1.96',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.46',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM418000E',
      Modelo: 'ECM418000E',
      Carcaça: '1',
      HP: '1.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '8.4870000000000001',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '29.8',
      Relé: 'RVA3AG6D',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '1F',
      Frequencia: '60',
      'LRA (A)': '65',
      'MCC (A)': '12.2',
      'Capacitor de Trabalho': '35/440',
      'Capacitor de Partida': '161-193/330',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2',
      Elet_Qc: '0.08',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.46500000000000002',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM418000J',
      Modelo: 'ECM418000J',
      Carcaça: '1',
      HP: '1.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '8.4870000000000001',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '29.8',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '25',
      'MCC (A)': '4.8',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0030000000000000001',
      Elet_Qc: '0.08',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.46500000000000002',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM418000T',
      Modelo: 'ECM418000T',
      Carcaça: '1',
      HP: '1./12',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '8.4870000000000001',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '29.8',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '46',
      'MCC (A)': '9.8000000000000007',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0030000000000000001',
      Elet_Qc: '0.08',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.46500000000000002',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM424000E',
      Modelo: 'ECM424000E',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '9.1080000000000005',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '30.1',
      Relé: 'RVA3AG6D',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '1F',
      Frequencia: '60',
      'LRA (A)': '65',
      'MCC (A)': '17',
      'Capacitor de Trabalho': '35/440',
      'Capacitor de Partida': '161-193/330',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.002',
      Elet_Qc: '0.01',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM424000J',
      Modelo: 'ECM424000J',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '9.1080000000000005',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '30.1',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '26',
      'MCC (A)': '5.2',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM424000T',
      Modelo: 'ECM424000T',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '9.1080000000000005',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '30.1',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '46',
      'MCC (A)': '10.1',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM430000J',
      Modelo: 'ECM430000J',
      Carcaça: '1',
      HP: '2.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '10.763999999999999',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '32.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '33',
      'MCC (A)': '6.3',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM430000T',
      Modelo: 'ECM430000T',
      Carcaça: '1',
      HP: '2.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '10.763999999999999',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '32.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '65',
      'MCC (A)': '14.1',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM437000E',
      Modelo: 'ECM437000E',
      Carcaça: '1',
      HP: '3',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '12.978899999999999',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '33.4',
      Relé: 'RVA3AG6D',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '1F',
      Frequencia: '60',
      'LRA (A)': '126',
      'MCC (A)': '21',
      'Capacitor de Trabalho': '35/440',
      'Capacitor de Partida': '161-193/330',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.001',
      Elet_Qc: '0.1',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM437000J',
      Modelo: 'ECM437000J',
      Carcaça: '1',
      HP: '3',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '12.978899999999999',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '33.4',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '40',
      'MCC (A)': '6.8',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.06',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM437000T',
      Modelo: 'ECM437000T',
      Carcaça: '1',
      HP: '3',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '12.978899999999999',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '33.4',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '86',
      'MCC (A)': '14.8',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.06',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM442000E',
      Modelo: 'ECM442000E',
      Carcaça: '1',
      HP: '3.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '15.359400000000001',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '33.6',
      Relé: 'RVA3AG6D',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '1F',
      Frequencia: '60',
      'LRA (A)': '126',
      'MCC (A)': '24.5',
      'Capacitor de Trabalho': '35/440',
      'Capacitor de Partida': '161-193/330',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0030000000000000001',
      Elet_Qc: '0.15',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM442000J',
      Modelo: 'ECM442000J',
      Carcaça: '1',
      HP: '3.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '15.359400000000001',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '33.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '42',
      'MCC (A)': '7.9',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM442000T',
      Modelo: 'ECM442000T',
      Carcaça: '1',
      HP: '3.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '15.359400000000001',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '33.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '88',
      'MCC (A)': '17.5',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM446000J',
      Modelo: 'ECM446000J',
      Carcaça: '2',
      HP: '3.3/4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '18.671399999999998',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '36.9',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '54',
      'MCC (A)': '9',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.51',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM446000T',
      Modelo: 'ECM446000T',
      Carcaça: '2',
      HP: '3.3/4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '18.671399999999998',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '36.9',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '96',
      'MCC (A)': '19.2',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.51',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM453000J',
      Modelo: 'ECM453000J',
      Carcaça: '2',
      HP: '4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '20.844899999999999',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '47.2',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '56',
      'MCC (A)': '11.7',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.43',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM453000T',
      Modelo: 'ECM453000T',
      Carcaça: '2',
      HP: '4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '20.844899999999999',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '47.2',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '108',
      'MCC (A)': '24.5',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.43',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM461000E',
      Modelo: 'ECM461000E',
      Carcaça: '2',
      HP: '5',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '23.287500000000001',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '47.3',
      Relé: 'RVA3AG6D',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '1F',
      Frequencia: '60',
      'LRA (A)': '183',
      'MCC (A)': '40.6',
      'Capacitor de Trabalho': '60/440',
      'Capacitor de Partida': '161-193/330',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0030000000000000001',
      Elet_Qc: '0.1',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM461000J',
      Modelo: 'ECM461000J',
      Carcaça: '2',
      HP: '5',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '23.287500000000001',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '47.3',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '59',
      'MCC (A)': '12.5',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.24',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM461000T',
      Modelo: 'ECM461000T',
      Carcaça: '2',
      HP: '5',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '23.287500000000001',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '47.3',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '128',
      'MCC (A)': '29',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.24',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM468000J',
      Modelo: 'ECM468000J',
      Carcaça: '2',
      HP: '5.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '25.750800000000002',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '48.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '62',
      'MCC (A)': '16',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.1',
      Elet_Qc: '0.34',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.47',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM468000T',
      Modelo: 'ECM468000T',
      Carcaça: '2',
      HP: '5.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '25.750800000000002',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '48.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '146',
      'MCC (A)': '31.9',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.1',
      Elet_Qc: '0.34',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.47',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM472000J',
      Modelo: 'ECM472000J',
      Carcaça: '2',
      HP: '6',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '27.903600000000004',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '49.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '64',
      'MCC (A)': '17.5',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '1.96',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.46',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM472000T',
      Modelo: 'ECM472000T',
      Carcaça: '2',
      HP: '6',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '27.903600000000004',
      'Deslocamento 50Hz (m3h)': '-',
      Refrigerante: 'R404A',
      Peso: '49.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '162',
      'MCC (A)': '37.1',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '1.96',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.46',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM24000J',
      Modelo: 'ECM24000J',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '7.5900000000000007',
      Refrigerante: 'R22',
      Peso: '30.1',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '26',
      'MCC (A)': '4.33',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM24000T',
      Modelo: 'ECM24000T',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '7.5900000000000007',
      Refrigerante: 'R22',
      Peso: '30.1',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '46',
      'MCC (A)': '8.42',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM30000J',
      Modelo: 'ECM30000J',
      Carcaça: '1',
      HP: '2.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '8.9699999999999989',
      Refrigerante: 'R22',
      Peso: '32.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '33',
      'MCC (A)': '5.42',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM30000T',
      Modelo: 'ECM30000T',
      Carcaça: '1',
      HP: '2.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '8.9699999999999989',
      Refrigerante: 'R22',
      Peso: '32.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '65',
      'MCC (A)': '12.08',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM37000J',
      Modelo: 'ECM37000J',
      Carcaça: '1',
      HP: '3',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '10.81575',
      Refrigerante: 'R22',
      Peso: '33.4',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '40',
      'MCC (A)': '5.67',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.06',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM37000T',
      Modelo: 'ECM37000T',
      Carcaça: '1',
      HP: '3',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '10.81575',
      Refrigerante: 'R22',
      Peso: '33.4',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '86',
      'MCC (A)': '12.33',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.06',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM42000J',
      Modelo: 'ECM42000J',
      Carcaça: '1',
      HP: '3.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '12.7995',
      Refrigerante: 'R22',
      Peso: '33.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '42',
      'MCC (A)': '6.42',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM42000T',
      Modelo: 'ECM42000T',
      Carcaça: '1',
      HP: '3.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '12.7995',
      Refrigerante: 'R22',
      Peso: '33.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '88',
      'MCC (A)': '14.17',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM46000J',
      Modelo: 'ECM46000J',
      Carcaça: '2',
      HP: '3.3/4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '15.559499999999998',
      Refrigerante: 'R22',
      Peso: '36.9',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '54',
      'MCC (A)': '7.5',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.51',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM46000T',
      Modelo: 'ECM46000T',
      Carcaça: '2',
      HP: '3.3/4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '15.559499999999998',
      Refrigerante: 'R22',
      Peso: '36.9',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '96',
      'MCC (A)': '16',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.51',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM53000J',
      Modelo: 'ECM53000J',
      Carcaça: '2',
      HP: '4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '17.370749999999997',
      Refrigerante: 'R22',
      Peso: '47.2',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '56',
      'MCC (A)': '9.75',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.43',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM53000T',
      Modelo: 'ECM53000T',
      Carcaça: '2',
      HP: '4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '17.370749999999997',
      Refrigerante: 'R22',
      Peso: '47.2',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '108',
      'MCC (A)': '20.420000000000002',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.43',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM61000J',
      Modelo: 'ECM61000J',
      Carcaça: '2',
      HP: '5',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '19.40625',
      Refrigerante: 'R22',
      Peso: '47.3',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '59',
      'MCC (A)': '10.42',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.24',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM61000T',
      Modelo: 'ECM61000T',
      Carcaça: '2',
      HP: '5',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '19.40625',
      Refrigerante: 'R22',
      Peso: '47.3',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '128',
      'MCC (A)': '24.17',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.24',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM68000J',
      Modelo: 'ECM68000J',
      Carcaça: '2',
      HP: '5.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '21.459',
      Refrigerante: 'R22',
      Peso: '48.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '62',
      'MCC (A)': '12.92',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.1',
      Elet_Qc: '0.34',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.47',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM68000T',
      Modelo: 'ECM68000T',
      Carcaça: '2',
      HP: '5.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '21.459',
      Refrigerante: 'R22',
      Peso: '48.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '146',
      'MCC (A)': '25.83',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.1',
      Elet_Qc: '0.34',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.47',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM72000J',
      Modelo: 'ECM72000J',
      Carcaça: '2',
      HP: '6',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '23.253000000000004',
      Refrigerante: 'R22',
      Peso: '49.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '64',
      'MCC (A)': '14.17',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '1.96',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.46',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM72000T',
      Modelo: 'ECM72000T',
      Carcaça: '2',
      HP: '6',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '23.253000000000004',
      Refrigerante: 'R22',
      Peso: '49.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Mineral',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '162',
      'MCC (A)': '30',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '1.96',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.46',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM418000J',
      Modelo: 'ECM418000J',
      Carcaça: '1',
      HP: '1.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '7.0724999999999998',
      Refrigerante: 'R404A',
      Peso: '29.8',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '25',
      'MCC (A)': '4',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0030000000000000001',
      Elet_Qc: '0.08',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.46500000000000002',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM418000T',
      Modelo: 'ECM418000T',
      Carcaça: '1',
      HP: '1./12',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '7.0724999999999998',
      Refrigerante: 'R404A',
      Peso: '29.8',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '46',
      'MCC (A)': '8.17',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0030000000000000001',
      Elet_Qc: '0.08',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.46500000000000002',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM424000J',
      Modelo: 'ECM424000J',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '7.5900000000000007',
      Refrigerante: 'R404A',
      Peso: '30.1',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '26',
      'MCC (A)': '4.33',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM424000T',
      Modelo: 'ECM424000T',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '7.5900000000000007',
      Refrigerante: 'R404A',
      Peso: '30.1',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '46',
      'MCC (A)': '8.42',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM430000J',
      Modelo: 'ECM430000J',
      Carcaça: '1',
      HP: '2.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '8.9699999999999989',
      Refrigerante: 'R404A',
      Peso: '32.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '33',
      'MCC (A)': '5.25',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM430000T',
      Modelo: 'ECM430000T',
      Carcaça: '1',
      HP: '2.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '8.9699999999999989',
      Refrigerante: 'R404A',
      Peso: '32.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '65',
      'MCC (A)': '11.75',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0070000000000000001',
      Elet_Qc: '0.04',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM437000J',
      Modelo: 'ECM437000J',
      Carcaça: '1',
      HP: '3',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '10.81575',
      Refrigerante: 'R404A',
      Peso: '33.4',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '40',
      'MCC (A)': '5.67',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.06',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM437000T',
      Modelo: 'ECM437000T',
      Carcaça: '1',
      HP: '3',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '10.81575',
      Refrigerante: 'R404A',
      Peso: '33.4',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '86',
      'MCC (A)': '12.33',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.06',
      'C-Volumetrico': '0.16',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM442000J',
      Modelo: 'ECM442000J',
      Carcaça: '1',
      HP: '3.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '12.7995',
      Refrigerante: 'R404A',
      Peso: '33.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '42',
      'MCC (A)': '6.58',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM442000T',
      Modelo: 'ECM442000T',
      Carcaça: '1',
      HP: '3.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '12.7995',
      Refrigerante: 'R404A',
      Peso: '33.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '88',
      'MCC (A)': '14.58',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.49',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM446000J',
      Modelo: 'ECM446000J',
      Carcaça: '2',
      HP: '3.3/4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '15.559499999999998',
      Refrigerante: 'R404A',
      Peso: '36.9',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '54',
      'MCC (A)': '7.5',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.51',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM446000T',
      Modelo: 'ECM446000T',
      Carcaça: '2',
      HP: '3.3/4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '15.559499999999998',
      Refrigerante: 'R404A',
      Peso: '36.9',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '96',
      'MCC (A)': '16',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.51',
      'C-Isoentropico': '0.51',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM453000J',
      Modelo: 'ECM453000J',
      Carcaça: '2',
      HP: '4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '17.370749999999997',
      Refrigerante: 'R404A',
      Peso: '47.2',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '56',
      'MCC (A)': '9.75',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.43',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM453000T',
      Modelo: 'ECM453000T',
      Carcaça: '2',
      HP: '4',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '17.370749999999997',
      Refrigerante: 'R404A',
      Peso: '47.2',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '108',
      'MCC (A)': '20.420000000000002',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.26',
      'C-Volumetrico': '0.21',
      'N-Volumetrico': '1.43',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM461000J',
      Modelo: 'ECM461000J',
      Carcaça: '2',
      HP: '5',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '19.40625',
      Refrigerante: 'R404A',
      Peso: '47.3',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '59',
      'MCC (A)': '10.42',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.24',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM461000T',
      Modelo: 'ECM461000T',
      Carcaça: '2',
      HP: '5',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '19.40625',
      Refrigerante: 'R404A',
      Peso: '47.3',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '128',
      'MCC (A)': '24.17',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.24',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.46',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM468000J',
      Modelo: 'ECM468000J',
      Carcaça: '2',
      HP: '5.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '21.459',
      Refrigerante: 'R404A',
      Peso: '48.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '62',
      'MCC (A)': '13.33',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.1',
      Elet_Qc: '0.34',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.47',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM468000T',
      Modelo: 'ECM468000T',
      Carcaça: '2',
      HP: '5.1/2',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '21.459',
      Refrigerante: 'R404A',
      Peso: '48.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '146',
      'MCC (A)': '26.58',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.1',
      Elet_Qc: '0.34',
      'C-Volumetrico': '0.18',
      'N-Volumetrico': '1.44',
      'C-Isoentropico': '0.47',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM472000J',
      Modelo: 'ECM472000J',
      Carcaça: '2',
      HP: '6',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '23.253000000000004',
      Refrigerante: 'R404A',
      Peso: '49.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '64',
      'MCC (A)': '14.58',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '1.96',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.46',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECM',
      Tipo: 'Alternativo',
      Código: 'ECM472000T',
      Modelo: 'ECM472000T',
      Carcaça: '2',
      HP: '6',
      Aplicação: 'MBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '-',
      'Deslocamento 50Hz (m3h)': '23.253000000000004',
      Refrigerante: 'R404A',
      Peso: '49.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '162',
      'MCC (A)': '30.92',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '1.96',
      Elet_Qc: '0.2',
      'C-Volumetrico': '0.17',
      'N-Volumetrico': '1.46',
      'C-Isoentropico': '0.45',
      'B-Isoentropico': '-0.1',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2464E',
      Modelo: 'ECB2464E',
      Carcaça: '1',
      HP: '1.1/2',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '10.763999999999999',
      'Deslocamento 50Hz (m3h)': '',
      Refrigerante: 'R404A',
      Peso: '33.700000000000003',
      Relé: 'RVA4A-G3R',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '1F',
      Frequencia: '60',
      'LRA (A)': '58',
      'MCC (A)': '16.8',
      'Capacitor de Trabalho': '161-193/330',
      'Capacitor de Partida': '35/440',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2',
      Elet_Qc: '0.05',
      'C-Volumetrico': '0.28000000000000003',
      'N-Volumetrico': '2.6',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '0.26500000000000001',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2464T',
      Modelo: 'ECB2464T',
      Carcaça: '1',
      HP: '1.1/2',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '10.763999999999999',
      'Deslocamento 50Hz (m3h)': '',
      Refrigerante: 'R404A',
      Peso: '33.700000000000003',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '46',
      'MCC (A)': '11.8',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.12',
      'C-Volumetrico': '0.28000000000000003',
      'N-Volumetrico': '2.6',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '0.26500000000000001',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2464J',
      Modelo: 'ECB2464J',
      Carcaça: '1',
      HP: '1.1/2',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '10.763999999999999',
      'Deslocamento 50Hz (m3h)': '',
      Refrigerante: 'R404A',
      Peso: '33.700000000000003',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '28',
      'MCC (A)': '5.8',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.12',
      'C-Volumetrico': '0.28000000000000003',
      'N-Volumetrico': '2.6',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '0.26500000000000001',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2480E',
      Modelo: 'ECB2480E',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '12.978899999999999',
      'Deslocamento 50Hz (m3h)': '',
      Refrigerante: 'R404A',
      Peso: '31.6',
      Relé: 'RVA4A- G3R',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '1F',
      Frequencia: '60',
      'LRA (A)': '98',
      'MCC (A)': '23.9',
      'Capacitor de Trabalho': '161-193/330',
      'Capacitor de Partida': '35/440',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2.5',
      Elet_Qc: '0.06',
      'C-Volumetrico': '0.28000000000000003',
      'N-Volumetrico': '2.5499999999999998',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '0.26500000000000001',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2480T',
      Modelo: 'ECB2480T',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '12.978899999999999',
      'Deslocamento 50Hz (m3h)': '',
      Refrigerante: 'R404A',
      Peso: '31.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '66',
      'MCC (A)': '13.1',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2.5',
      Elet_Qc: '0.16',
      'C-Volumetrico': '0.28000000000000003',
      'N-Volumetrico': '2.5499999999999998',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '0.26500000000000001',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2480J',
      Modelo: 'ECB2480J',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '12.978899999999999',
      'Deslocamento 50Hz (m3h)': '',
      Refrigerante: 'R404A',
      Peso: '31.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '32',
      'MCC (A)': '6.2',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2.5',
      Elet_Qc: '0.16',
      'C-Volumetrico': '0.28000000000000003',
      'N-Volumetrico': '2.5499999999999998',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '0.26500000000000001',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2511T',
      Modelo: 'ECB2511T',
      Carcaça: '1',
      HP: '3',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '15.359400000000001',
      'Deslocamento 50Hz (m3h)': '',
      Refrigerante: 'R404A',
      Peso: '31.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '78',
      'MCC (A)': '15.8',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2.5',
      Elet_Qc: '0.16',
      'C-Volumetrico': '0.28499999999999998',
      'N-Volumetrico': '2.5499999999999998',
      'C-Isoentropico': '0.73499999999999999',
      'B-Isoentropico': '0.28199999999999997',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2511J',
      Modelo: 'ECB2511J',
      Carcaça: '1',
      HP: '3',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '15.359400000000001',
      'Deslocamento 50Hz (m3h)': '',
      Refrigerante: 'R404A',
      Peso: '31.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '38',
      'MCC (A)': '8.6',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2.5',
      Elet_Qc: '0.16',
      'C-Volumetrico': '0.28499999999999998',
      'N-Volumetrico': '2.5499999999999998',
      'C-Isoentropico': '0.73499999999999999',
      'B-Isoentropico': '0.28199999999999997',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2516T',
      Modelo: 'ECB2516T',
      Carcaça: '2',
      HP: '4',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '23.287500000000001',
      'Deslocamento 50Hz (m3h)': '',
      Refrigerante: 'R404A',
      Peso: '46.3',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '98',
      'MCC (A)': '23.6',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2.5',
      Elet_Qc: '0.21',
      'C-Volumetrico': '0.31',
      'N-Volumetrico': '2.4500000000000002',
      'C-Isoentropico': '0.7',
      'B-Isoentropico': '0.25',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2516J',
      Modelo: 'ECB2516J',
      Carcaça: '2',
      HP: '4',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '23.287500000000001',
      'Deslocamento 50Hz (m3h)': '',
      Refrigerante: 'R404A',
      Peso: '46.3',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '52',
      'MCC (A)': '12.8',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2.5',
      Elet_Qc: '0.21',
      'C-Volumetrico': '0.31',
      'N-Volumetrico': '2.4500000000000002',
      'C-Isoentropico': '0.7',
      'B-Isoentropico': '0.28000000000000003',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2522T',
      Modelo: 'ECB2522T',
      Carcaça: '2',
      HP: '5',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '27.903600000000012',
      'Deslocamento 50Hz (m3h)': '',
      Refrigerante: 'R404A',
      Peso: '46.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '120',
      'MCC (A)': '32.6',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-1.2',
      Elet_Qc: '0.21',
      'C-Volumetrico': '0.31',
      'N-Volumetrico': '2.5',
      'C-Isoentropico': '0.71499999999999997',
      'B-Isoentropico': '0.3',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2522J',
      Modelo: 'ECB2522J',
      Carcaça: '2',
      HP: '5',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '27.903600000000012',
      'Deslocamento 50Hz (m3h)': '',
      Refrigerante: 'R404A',
      Peso: '46.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '60',
      'LRA (A)': '66',
      'MCC (A)': '15.2',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-1.2',
      Elet_Qc: '0.21',
      'C-Volumetrico': '0.31',
      'N-Volumetrico': '2.5',
      'C-Isoentropico': '0.71499999999999997',
      'B-Isoentropico': '0.3',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2464T',
      Modelo: 'ECB2464T',
      Carcaça: '1',
      HP: '1.1/2',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '',
      'Deslocamento 50Hz (m3h)': '8.9700000000000006',
      Refrigerante: 'R404A',
      Peso: '33.700000000000003',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '46',
      'MCC (A)': '9.83',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.12',
      'C-Volumetrico': '0.28000000000000003',
      'N-Volumetrico': '2.6',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '0.26500000000000001',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2464J',
      Modelo: 'ECB2464J',
      Carcaça: '1',
      HP: '1.1/2',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '',
      'Deslocamento 50Hz (m3h)': '8.9700000000000006',
      Refrigerante: 'R404A',
      Peso: '33.700000000000003',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '28',
      'MCC (A)': '4.83',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '0.0080000000000000002',
      Elet_Qc: '0.12',
      'C-Volumetrico': '0.28000000000000003',
      'N-Volumetrico': '2.6',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '0.26500000000000001',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2480T',
      Modelo: 'ECB2480T',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '',
      'Deslocamento 50Hz (m3h)': '10.81575',
      Refrigerante: 'R404A',
      Peso: '31.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '66',
      'MCC (A)': '10.92',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2.5',
      Elet_Qc: '0.16',
      'C-Volumetrico': '0.28000000000000003',
      'N-Volumetrico': '2.5499999999999998',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '0.26500000000000001',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2480J',
      Modelo: 'ECB2480J',
      Carcaça: '1',
      HP: '2',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '',
      'Deslocamento 50Hz (m3h)': '10.81575',
      Refrigerante: 'R404A',
      Peso: '31.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '32',
      'MCC (A)': '5.17',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2.5',
      Elet_Qc: '0.16',
      'C-Volumetrico': '0.28000000000000003',
      'N-Volumetrico': '2.5499999999999998',
      'C-Isoentropico': '0.75',
      'B-Isoentropico': '0.26500000000000001',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2511T',
      Modelo: 'ECB2511T',
      Carcaça: '1',
      HP: '3',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '',
      'Deslocamento 50Hz (m3h)': '12.799500000000002',
      Refrigerante: 'R404A',
      Peso: '31.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '78',
      'MCC (A)': '13.17',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2.5',
      Elet_Qc: '0.16',
      'C-Volumetrico': '0.28499999999999998',
      'N-Volumetrico': '2.5499999999999998',
      'C-Isoentropico': '0.73499999999999999',
      'B-Isoentropico': '0.28199999999999997',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2511J',
      Modelo: 'ECB2511J',
      Carcaça: '1',
      HP: '3',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '',
      'Deslocamento 50Hz (m3h)': '12.799500000000002',
      Refrigerante: 'R404A',
      Peso: '31.6',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '1.5',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '38',
      'MCC (A)': '7.17',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2.5',
      Elet_Qc: '0.16',
      'C-Volumetrico': '0.28499999999999998',
      'N-Volumetrico': '2.5499999999999998',
      'C-Isoentropico': '0.73499999999999999',
      'B-Isoentropico': '0.28199999999999997',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2516T',
      Modelo: 'ECB2516T',
      Carcaça: '2',
      HP: '4',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '',
      'Deslocamento 50Hz (m3h)': '19.406250000000004',
      Refrigerante: 'R404A',
      Peso: '46.3',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '98',
      'MCC (A)': '19.670000000000002',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2.5',
      Elet_Qc: '0.21',
      'C-Volumetrico': '0.31',
      'N-Volumetrico': '2.4500000000000002',
      'C-Isoentropico': '0.7',
      'B-Isoentropico': '0.25',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2516J',
      Modelo: 'ECB2516J',
      Carcaça: '2',
      HP: '4',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '',
      'Deslocamento 50Hz (m3h)': '19.406250000000004',
      Refrigerante: 'R404A',
      Peso: '46.3',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '52',
      'MCC (A)': '10.67',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-2.5',
      Elet_Qc: '0.21',
      'C-Volumetrico': '0.31',
      'N-Volumetrico': '2.4500000000000002',
      'C-Isoentropico': '0.7',
      'B-Isoentropico': '0.28000000000000003',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2522T',
      Modelo: 'ECB2522T',
      Carcaça: '2',
      HP: '5',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '',
      'Deslocamento 50Hz (m3h)': '23.253000000000011',
      Refrigerante: 'R404A',
      Peso: '46.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '220',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '120',
      'MCC (A)': '27.17',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-1.2',
      Elet_Qc: '0.21',
      'C-Volumetrico': '0.31',
      'N-Volumetrico': '2.5',
      'C-Isoentropico': '0.71499999999999997',
      'B-Isoentropico': '0.3',
    },
    {
      Marca: 'ECB',
      Tipo: 'Alternativo',
      Código: 'ECB2522J',
      Modelo: 'ECB2522J',
      Carcaça: '2',
      HP: '5',
      Aplicação: 'LBP',
      'Torque de Partida': 'N/A',
      'Deslocamento 60Hz (m3h)': '',
      'Deslocamento 50Hz (m3h)': '23.253000000000011',
      Refrigerante: 'R404A',
      Peso: '46.5',
      Relé: '-',
      'Protetor Térmico': '-',
      'Sucção (in)': '3/4',
      'Descarga (in)': '1/2',
      Óleo: 'Poliol Éster',
      'Carga de Óleo (L)': '2',
      'Tensão (V)': '380',
      Fase: '3F',
      Frequencia: '50',
      'LRA (A)': '66',
      'MCC (A)': '12.67',
      'Capacitor de Trabalho': '-',
      'Capacitor de Partida': '-',
      'Controle de Capacidade ': 'N/A',
      'Resistencia de Carter': '-',
      'Nivel de ruido': '',
      'A (mm)': '',
      'B (mm)': '',
      'C (mm)': '',
      'D (mm)': '',
      'E (mm)': '',
      Elet_Kp: '-1.2',
      Elet_Qc: '0.21',
      'C-Volumetrico': '0.31',
      'N-Volumetrico': '2.5',
      'C-Isoentropico': '0.71499999999999997',
      'B-Isoentropico': '0.3',
    },
  ];

  static getCondenser = (data) => api.get(`https://run.mocky.io/v3/4d92c4aa-e8f7-4dff-b8cf-4d7601aaaa37`, data);

  static getAllSystems = (projectId) => api.get(`/v1/projects/${projectId}/operating-systems`);

  static getSystemById = (projectId, systemId) => api.get(`/v1/projects/${projectId}/operating-systems/${systemId}`);

  static createSystem = (projectId, data) => api.post(`/v1/projects/${projectId}/operating-systems`, data);

  static updateSystem = (projectId, systemId, data) =>
    api.put(`/v1/projects/${projectId}/operating-systems/${systemId}`, data);

  static getRefrigerantFluids = () => api.get(`/v1/refrigerants`);

  static compressorCalculation = (compressor, params) => api.post(`/v1/compressor/calculation`);

  static calculateResult = (data) => api.post(`/v1/catalog/calculation`, data);

  static parseConfiguration = (data): any => {
    const { active, type, refrigerantFluid, compressor, condenser, ...rest } = data;
    return rest;
  };

  static getComparison = (data: any[]) => api.post(`/v1/catalog/comparison`, data);

  static optionalsEvaporators = [
    {
      linha: 'Todos',
      productLine: ['HP', 'MP', 'EP', 'EDH', 'FL', 'FM', 'FXB+', 'EU', 'FBA', 'VCM', 'ET', 'FL+'],
      delta_temperature_difference: [
        [[10, 11], [10]],
        [[6, 7], [6]],
        [[8, 9], [8]],
        [[8, 9, 10], [10]],
      ],
      defrost: ['Ar', 'Elétrico', 'Gás'],
      helixDiameter: [],
      packaging: [],
      fpi: [],
      chamber: ['Com Pintura', 'Sem Pintura'],
      chamberFins: [],
      gicle: [
        'N/A',
        '10',
        '15',
        '12',
        '17',
        '20',
        '5',
        '4',
        '25',
        '6',
        '8',
        '3',
        '40',
        '30',
        '35',
        '50',
        'Sem',
        '2',
        '1',
        '2,5',
      ],
      valveKit: [
        'N/A',
        'TEX12',
        'TES12',
        'E3V45',
        'E3V55',
        'E3V65',
        'TES5',
        'TES20',
        'TEX5',
        'TES55',
        'TEX20',
        'E2V35',
        'E2V30',
        'TES2',
        'Sem',
        'E2V18',
        'TEX2',
        'E2V24',
        'E2V14',
        'TEN2',
        'TEN5',
      ],
      marketStandard: [],
      engine: [],
      numberOfFans: [2, 3, 4, 1, 5, 6, 7, 8, 9],
      optionals: [],
      orifice: ['N/A', '5', '6', '2', '8', '4', '7', '3', '9', '10', '13', '12', 'Sem', '1'],
      finsProtection: ['Sem Proteção', 'Com Proteção', 'Sem'],
      voltage: [220, 440, 0, 380, 127],
      voltageAndDefrost: [],
      valveType: ['Termostática', 'Sem', 'EVD ice', 'Eletrônica'],
      version: [],
      finsPerInch: ['6', '4', '2.5', '5'],
      isolatedTray: ['Sem', 'Com'],
      engineType: ['AC', 'AC ELGIN', 'EC', 'Polo Sombreado', 'Eletrônico 1 Velocidade', 'Eletrônico 2 Velocidades'],
      expansionValve: ['Termostática', 'Sem', 'EVD ice', 'Eletrônica'],
      logo: ['Elgin'],
      powerSupply60Hz: [220, 440, 380, 127],
      powerSupply50Hz: [220, 0, 380],
      powerSupplyPhases: [3, 1],
      fanDiameter: [800, 450, 500, 300, 400, 254, 910, 203],
    },
    {
      linha: 'HP',
      productLine: ['HP'],
      delta_temperature_difference: [
        [[10, 11], [10]],
        [[6, 7], [6]],
        [[8, 9], [8]],
      ],
      defrost: ['Ar', 'Elétrico', 'Gás'],
      helixDiameter: [],
      packaging: [],
      fpi: [],
      chamber: ['Com Pintura'],
      chamberFins: [],
      gicle: ['N/A', '10', '15', '12', '17', '20', '5', '25', '6', '8', '4', '3', '40', '30', '35', '50'],
      valveKit: [
        'N/A',
        'TEX12',
        'TES12',
        'E3V45',
        'E3V55',
        'E3V65',
        'TES20',
        'TEX5',
        'TES5',
        'TES55',
        'TEX20',
        'E2V35',
        'E2V30',
      ],
      marketStandard: [],
      engine: [],
      numberOfFans: [2, 3, 4, 1],
      optionals: [],
      orifice: ['N/A', '5', '6', '8', '4', '7', '2', '3', '9', '10', '13', '12'],
      finsProtection: ['Sem Proteção', 'Com Proteção'],
      voltage: [220, 440, 0, 380],
      voltageAndDefrost: [],
      valveType: ['Termostática', 'Sem', 'EVD ice', 'Eletrônica'],
      version: [],
      finsPerInch: ['6', '4'],
      isolatedTray: ['Sem'],
      engineType: ['AC'],
      expansionValve: ['Termostática', 'Sem', 'EVD ice', 'Eletrônica'],
      logo: ['Elgin'],
      powerSupply60Hz: [220, 440, 380],
      powerSupply50Hz: [220, 0, 380],
      powerSupplyPhases: [3],
      fanDiameter: [800],
    },
    {
      linha: 'MP',
      productLine: ['MP'],
      delta_temperature_difference: [
        [[6, 7], [6]],
        [[10, 11], [10]],
        [[8, 9], [8]],
      ],
      defrost: ['Ar', 'Elétrico', 'Gás'],
      helixDiameter: [],
      packaging: [],
      fpi: [],
      chamber: ['Com Pintura'],
      chamberFins: [],
      gicle: ['4', 'N/A', '17', '20', '10', '2', '1', '3', '6', '15', '5', '12', '8'],
      valveKit: [
        'TES5',
        'N/A',
        'E3V45',
        'TES2',
        'E2V18',
        'TEX2',
        'E2V24',
        'E2V30',
        'TEX5',
        'E2V35',
        'E2V14',
        'TEX12',
        'TES12',
        'TES20',
      ],
      marketStandard: [],
      engine: [],
      numberOfFans: [3, 5, 2, 1, 4],
      optionals: [],
      orifice: ['2', 'N/A', '3', '4', '6', '5', '1', '8'],
      finsProtection: ['Sem Proteção', 'Com Proteção'],
      voltage: [220, 380, 440, 0],
      voltageAndDefrost: [],
      valveType: ['Termostática', 'EVD ice', 'Sem', 'Eletrônica'],
      version: [],
      finsPerInch: ['6', '4'],
      isolatedTray: ['Sem'],
      engineType: ['AC ELGIN', 'AC', 'EC'],
      expansionValve: ['Termostática', 'EVD ice', 'Sem', 'Eletrônica'],
      logo: ['Elgin'],
      powerSupply60Hz: [220, 380, 440],
      powerSupply50Hz: [220, 380, 0],
      powerSupplyPhases: [1, 3],
      fanDiameter: [450],
    },
    {
      linha: 'EP',
      productLine: ['EP'],
      delta_temperature_difference: [
        [[6, 7], [6]],
        [[8, 9], [8]],
      ],
      defrost: ['Elétrico', 'Ar'],
      helixDiameter: [],
      packaging: [],
      fpi: [],
      chamber: ['Sem Pintura'],
      chamberFins: [],
      gicle: ['3', 'N/A', '4', '5', '6', '8', '17', '15', '40', '10', '12', '25', '50', '20', '35'],
      valveKit: ['N/A', 'TES5', 'TES12', 'TES20', 'TES55'],
      marketStandard: [],
      engine: [],
      numberOfFans: [1, 2, 3],
      optionals: [],
      orifice: ['N/A', '2', '3', '4', '5', '6', '8', '7', '12'],
      finsProtection: ['Sem Proteção'],
      voltage: [220, 440, 0, 380],
      voltageAndDefrost: [],
      valveType: ['Sem', 'Termostática'],
      version: [],
      finsPerInch: ['4', '2.5'],
      isolatedTray: ['Sem', 'Com'],
      engineType: ['AC', 'EC'],
      expansionValve: ['Sem', 'Termostática'],
      logo: ['Elgin'],
      powerSupply60Hz: [220, 440, 380],
      powerSupply50Hz: [220, 0, 380],
      powerSupplyPhases: [3],
      fanDiameter: [500],
    },
    {
      linha: 'EDH',
      productLine: ['EDH'],
      delta_temperature_difference: [
        [[6, 7], [6]],
        [[8, 9], [8]],
        [[10, 11], [10]],
      ],
      defrost: ['Ar', 'Elétrico'],
      helixDiameter: [],
      packaging: [],
      fpi: [],
      chamber: ['Com Pintura', 'Sem Pintura'],
      chamberFins: [],
      gicle: ['Sem'],
      valveKit: ['N/A', 'TES2'],
      marketStandard: [],
      engine: [],
      numberOfFans: [1, 2, 3, 4, 5],
      optionals: [],
      orifice: ['N/A', '2'],
      finsProtection: ['Com Proteção', 'Sem Proteção'],
      voltage: [220],
      voltageAndDefrost: [],
      valveType: ['Sem', 'Termostática'],
      version: [],
      finsPerInch: ['6', '4'],
      isolatedTray: ['Sem'],
      engineType: ['Polo Sombreado', 'Eletrônico 1 Velocidade', 'Eletrônico 2 Velocidades'],
      expansionValve: ['Sem', 'Termostática'],
      logo: ['Elgin'],
      powerSupply60Hz: [220],
      powerSupply50Hz: [220],
      powerSupplyPhases: [1],
      fanDiameter: [300],
    },
    {
      linha: 'FL',
      productLine: ['FL'],
      delta_temperature_difference: [
        [[6, 7], [6]],
        [[8, 9], [8]],
        [[10, 11], [10]],
      ],
      defrost: ['Ar', 'Elétrico'],
      helixDiameter: [],
      packaging: [],
      fpi: [],
      chamber: ['Sem Pintura'],
      chamberFins: [],
      gicle: ['Sem'],
      valveKit: ['Sem'],
      marketStandard: [],
      engine: [],
      numberOfFans: [1, 2, 3, 4, 5, 6, 7, 8],
      optionals: [],
      orifice: ['Sem'],
      finsProtection: ['Sem Proteção'],
      voltage: [220],
      voltageAndDefrost: [],
      valveType: ['Sem'],
      version: [],
      finsPerInch: ['5'],
      isolatedTray: ['Sem'],
      engineType: ['Polo Sombreado'],
      expansionValve: ['Sem'],
      logo: ['Elgin'],
      powerSupply60Hz: [220],
      powerSupply50Hz: [220],
      powerSupplyPhases: [1],
      fanDiameter: [300],
    },
    {
      linha: 'FM',
      productLine: ['FM'],
      delta_temperature_difference: [
        [[6, 7], [6]],
        [[8, 9], [8]],
        [[10, 11], [10]],
      ],
      defrost: ['Ar', 'Elétrico'],
      helixDiameter: [],
      packaging: [],
      fpi: [],
      chamber: ['Sem Pintura'],
      chamberFins: [],
      gicle: ['Sem'],
      valveKit: ['Sem'],
      marketStandard: [],
      engine: [],
      numberOfFans: [1, 2, 3, 4, 5],
      optionals: [],
      orifice: ['Sem'],
      finsProtection: ['Sem Proteção'],
      voltage: [220, 380, 440, 0],
      voltageAndDefrost: [],
      valveType: ['Sem'],
      version: [],
      finsPerInch: ['4', '6'],
      isolatedTray: ['Sem'],
      engineType: ['AC'],
      expansionValve: ['Sem'],
      logo: ['Elgin'],
      powerSupply60Hz: [220, 380, 440],
      powerSupply50Hz: [220, 380, 0],
      powerSupplyPhases: [1, 3],
      fanDiameter: [400],
    },
    {
      linha: 'FXB+',
      productLine: ['FXB+'],
      delta_temperature_difference: [
        [[6, 7], [6]],
        [[8, 9], [8]],
        [[10, 11], [10]],
      ],
      defrost: ['Elétrico', 'Ar'],
      helixDiameter: [],
      packaging: [],
      fpi: [],
      chamber: ['Sem Pintura'],
      chamberFins: [],
      gicle: ['Sem'],
      valveKit: ['Sem'],
      marketStandard: [],
      engine: [],
      numberOfFans: [1, 2, 3, 4, 5, 6],
      optionals: [],
      orifice: ['Sem'],
      finsProtection: ['Sem Proteção'],
      voltage: [220],
      voltageAndDefrost: [],
      valveType: ['Sem'],
      version: [],
      finsPerInch: ['4'],
      isolatedTray: ['Sem'],
      engineType: ['Polo Sombreado'],
      expansionValve: ['Sem'],
      logo: ['Elgin'],
      powerSupply60Hz: [220],
      powerSupply50Hz: [220],
      powerSupplyPhases: [1],
      fanDiameter: [254],
    },
    {
      linha: 'EU',
      productLine: ['EU'],
      delta_temperature_difference: [
        [[6, 7], [6]],
        [[8, 9], [8]],
        [[10, 11], [10]],
      ],
      defrost: ['Gás', 'Elétrico'],
      helixDiameter: [],
      packaging: [],
      fpi: [],
      chamber: ['Com Pintura'],
      chamberFins: [],
      gicle: ['N/A', '8', '12', '15', '5', '6', '10', '17', '20', '25', '30'],
      valveKit: ['N/A', 'TES12', 'TEX12', 'TES5', 'TEX5', 'E2V30', 'E2V35', 'E3V45', 'E3V55', 'E2V24', 'E3V65'],
      marketStandard: [],
      engine: [],
      numberOfFans: [2, 3, 4, 5],
      optionals: [],
      orifice: ['N/A', '5', '6', '7', '4'],
      finsProtection: ['Com Proteção'],
      voltage: [220, 440, 0, 380],
      voltageAndDefrost: [],
      valveType: ['Termostática', 'EVD ice'],
      version: [],
      finsPerInch: ['4'],
      isolatedTray: ['Sem'],
      engineType: ['EC'],
      expansionValve: ['Termostática', 'EVD ice'],
      logo: ['Elgin'],
      powerSupply60Hz: [220, 440, 380],
      powerSupply50Hz: [220, 0, 380],
      powerSupplyPhases: [3],
      fanDiameter: [910],
    },
    {
      linha: 'FBA',
      productLine: ['FBA'],
      delta_temperature_difference: [
        [[6, 7], [6]],
        [[8, 9, 10], [10]],
      ],
      defrost: ['Ar', 'Elétrico'],
      helixDiameter: [],
      packaging: [],
      fpi: [],
      chamber: ['Com Pintura'],
      chamberFins: [],
      gicle: ['Sem', '1', 'N/A', '2', '2,5', '5', '6'],
      valveKit: ['Sem', 'TEN2', 'N/A', 'TES2', 'TES5', 'TEN5'],
      marketStandard: [],
      engine: [],
      numberOfFans: [1, 2, 3, 4, 5, 6],
      optionals: [],
      orifice: ['Sem', '1', 'N/A', '2', '3', '4', '5', '6'],
      finsProtection: ['Com Proteção'],
      voltage: [220],
      voltageAndDefrost: [],
      valveType: ['Sem', 'Termostática'],
      version: [],
      finsPerInch: ['4', '6'],
      isolatedTray: ['Sem'],
      engineType: ['Eletrônico 1 Velocidade'],
      expansionValve: ['Sem', 'Termostática'],
      logo: ['Elgin'],
      powerSupply60Hz: [220],
      powerSupply50Hz: [220],
      powerSupplyPhases: [1],
      fanDiameter: [254],
    },
    {
      linha: 'VCM',
      productLine: ['VCM'],
      delta_temperature_difference: [[[6, 7], [6]]],
      defrost: ['Ar', 'Elétrico'],
      helixDiameter: [],
      packaging: [],
      fpi: [],
      chamber: ['Sem Pintura'],
      chamberFins: [],
      gicle: ['Sem'],
      valveKit: ['Sem'],
      marketStandard: [],
      engine: [],
      numberOfFans: [1, 2, 3, 4, 5],
      optionals: [],
      orifice: ['Sem'],
      finsProtection: ['Sem Proteção'],
      voltage: [127, 0, 220],
      voltageAndDefrost: [],
      valveType: ['Sem'],
      version: [],
      finsPerInch: ['5'],
      isolatedTray: ['Sem'],
      engineType: ['AC'],
      expansionValve: ['Sem'],
      logo: ['Elgin'],
      powerSupply60Hz: [127, 220],
      powerSupply50Hz: [0, 220],
      powerSupplyPhases: [1],
      fanDiameter: [203],
    },
    {
      linha: 'ET',
      productLine: ['ET'],
      delta_temperature_difference: [
        [[6, 7], [6]],
        [[8, 9], [8]],
        [[10, 11], [10]],
      ],
      defrost: ['Elétrico', 'Gás'],
      helixDiameter: [],
      packaging: [],
      fpi: [],
      chamber: ['Com Pintura'],
      chamberFins: [],
      gicle: ['N/A', '12', '6', '10', '15', '30', '17'],
      valveKit: ['N/A', 'E2V30'],
      marketStandard: [],
      engine: [],
      numberOfFans: [3, 6, 9],
      optionals: [],
      orifice: ['N/A'],
      finsProtection: ['Com Proteção'],
      voltage: [220, 380],
      voltageAndDefrost: [],
      valveType: ['Sem', 'EVD ice'],
      version: [],
      finsPerInch: ['4'],
      isolatedTray: ['Sem'],
      engineType: ['AC'],
      expansionValve: ['Sem', 'EVD ice'],
      logo: ['Elgin'],
      powerSupply60Hz: [220, 380],
      powerSupply50Hz: [220, 380],
      powerSupplyPhases: [3],
      fanDiameter: [500],
    },
    {
      linha: 'FL+',
      productLine: ['FL+'],
      delta_temperature_difference: [
        [[6, 7], [6]],
        [[8, 9], [8]],
      ],
      defrost: ['Elétrico'],
      helixDiameter: [],
      packaging: [],
      fpi: [],
      chamber: ['Sem Pintura'],
      chamberFins: [],
      gicle: ['Sem'],
      valveKit: ['Sem'],
      marketStandard: [],
      engine: [],
      numberOfFans: [1, 2, 3, 4, 5, 6, 7, 8],
      optionals: [],
      orifice: ['Sem'],
      finsProtection: ['Sem'],
      voltage: [220],
      voltageAndDefrost: [],
      valveType: ['Sem'],
      version: [],
      finsPerInch: ['4'],
      isolatedTray: ['Sem'],
      engineType: ['AC'],
      expansionValve: ['Sem'],
      logo: ['Elgin'],
      powerSupply60Hz: [220],
      powerSupply50Hz: [220],
      powerSupplyPhases: [1],
      fanDiameter: [300],
    },
  ];

  static optionalsUnitCondensing = [
    {
      linha: 'Todos',
      productLine: ['US', ' SLIM', 'UV 18 A 44 HP', 'US 10 66 HP', 'ES+', 'UCM0', 'UCMB', 'SLMB'],
      refrigerantFluid: ['R404A', 'R134a', 'R22', 'R448A', 'R134A'],
      compressorType: ['Semi-Hermético', 'Scroll', 'Hermético', 'Alternativo'],
      compressor: ['Bitzer', 'Elgin', 'Copeland'],
      logo: ['Elgin'],
      chamber: ['Sem', 'Com'],
      numberOfCompressors: ['1', '3', '2'],
      hotAirDefrost: ['Sem', 'Com', 'Não'],
      capacityControl: ['Sem', '30% a 100%', 'Com', 'Em Estágios', '35 a 100%'],
      condensationControl: ['Sem', 'Com'],
      oilSeparator: ['Com', 'Sem', 'Não', 'Sim'],
      suctionAccumulator: ['Sem', 'Com', 'Não', 'Sim'],
      suctionFilter: ['Sem', 'Com'],
      contactor: ['Sem', 'Com', 'Não'],
      liquidServiceValve: ['Com', 'Sem'],
      tankInletValve: ['Com', 'Sem'],
      liquidFilter: ['Com', 'Sem'],
      tank: ['Com', 'Sem'],
      viewfinder: ['Com', 'Sem'],
      insulationinTheSuctionLine: ['Sem', 'Com'],
      suctionServiceValve: ['Com', 'Sem', 'Não', 'Sim'],
      overloadRelay: ['Sem', 'Com', 'Não'],
      circuitBreaker: ['Sem', 'Com', 'Não'],
      sequenceRelayAndPhaseOutage: ['Sem', 'Com', 'Não', 'Sim'],
      controller: ['Sem', 'Com', '2'],
      elgin_smart: ['Sem', 'Com'],
    },
    {
      linha: 'US',
      productLine: ['US'],
      refrigerantFluid: ['R404A', 'R134a'],
      compressorType: ['Semi-Hermético', 'Scroll'],
      compressor: ['Bitzer', 'Elgin', 'Copeland'],
      logo: ['Elgin'],
      chamber: ['Sem', 'Com'],
      numberOfCompressors: ['1'],
      hotAirDefrost: ['Sem', 'Com'],
      capacityControl: ['Sem', '30% a 100%'],
      condensationControl: ['Sem', 'Com'],
      oilSeparator: ['Com', 'Sem'],
      suctionAccumulator: ['Sem', 'Com'],
      suctionFilter: ['Sem', 'Com'],
      contactor: ['Sem', 'Com'],
      liquidServiceValve: ['Com', 'Sem'],
      tankInletValve: ['Com'],
      liquidFilter: ['Com'],
      tank: ['Com'],
      viewfinder: ['Com'],
      insulationinTheSuctionLine: ['Sem', 'Com'],
      suctionServiceValve: ['Com'],
      overloadRelay: ['Sem', 'Com'],
      circuitBreaker: ['Sem', 'Com'],
      sequenceRelayAndPhaseOutage: ['Sem', 'Com'],
      controller: ['Sem', 'Com'],
      elgin_smart: ['Sem', 'Com'],
    },
    {
      linha: ' SLIM',
      productLine: [' SLIM'],
      refrigerantFluid: ['R22', 'R404A', 'R134a'],
      compressorType: ['Hermético'],
      compressor: ['Copeland', 'Elgin'],
      logo: ['Elgin'],
      chamber: ['Sem'],
      numberOfCompressors: ['1'],
      hotAirDefrost: ['Sem'],
      capacityControl: ['Sem'],
      condensationControl: ['Sem'],
      oilSeparator: ['Sem'],
      suctionAccumulator: ['Sem'],
      suctionFilter: ['Sem'],
      contactor: ['Sem'],
      liquidServiceValve: ['Sem'],
      tankInletValve: ['Sem', 'Com'],
      liquidFilter: ['Com'],
      tank: ['Sem', 'Com'],
      viewfinder: ['Sem', 'Com'],
      insulationinTheSuctionLine: ['Sem'],
      suctionServiceValve: ['Sem'],
      overloadRelay: ['Sem'],
      circuitBreaker: ['Sem'],
      sequenceRelayAndPhaseOutage: ['Sem'],
      controller: ['Sem'],
      elgin_smart: ['Sem'],
    },
    {
      linha: 'UV 18 A 44 HP',
      productLine: ['UV 18 A 44 HP'],
      refrigerantFluid: ['R404A'],
      compressorType: ['Semi-Hermético'],
      compressor: ['Bitzer', 'Elgin'],
      logo: ['Elgin'],
      chamber: ['Com'],
      numberOfCompressors: ['1'],
      hotAirDefrost: ['Sem', 'Com'],
      capacityControl: ['Sem', 'Com'],
      condensationControl: ['Com', 'Sem'],
      oilSeparator: ['Com'],
      suctionAccumulator: ['Com'],
      suctionFilter: ['Com'],
      contactor: ['Com'],
      liquidServiceValve: ['Com'],
      tankInletValve: ['Com'],
      liquidFilter: ['Com'],
      tank: ['Com'],
      viewfinder: ['Com'],
      insulationinTheSuctionLine: ['Com'],
      suctionServiceValve: ['Com'],
      overloadRelay: ['Com'],
      circuitBreaker: ['Com'],
      sequenceRelayAndPhaseOutage: ['Com'],
      controller: ['Sem', 'Com'],
      elgin_smart: ['Com'],
    },
    {
      linha: 'US 10 66 HP',
      productLine: ['US 10 66 HP'],
      refrigerantFluid: ['R404A', 'R134a'],
      compressorType: ['Scroll', 'Semi-Hermético'],
      compressor: ['Copeland', 'Bitzer', 'Elgin'],
      logo: ['Elgin'],
      chamber: ['Com'],
      numberOfCompressors: ['3', '2'],
      hotAirDefrost: ['Sem', 'Com'],
      capacityControl: ['Em Estágios', '30% a 100%', '35 a 100%'],
      condensationControl: ['Sem', 'Com'],
      oilSeparator: ['Com'],
      suctionAccumulator: ['Com'],
      suctionFilter: ['Com'],
      contactor: ['Com'],
      liquidServiceValve: ['Com'],
      tankInletValve: ['Com'],
      liquidFilter: ['Com'],
      tank: ['Com'],
      viewfinder: ['Com'],
      insulationinTheSuctionLine: ['Com'],
      suctionServiceValve: ['Com'],
      overloadRelay: ['Com'],
      circuitBreaker: ['Com'],
      sequenceRelayAndPhaseOutage: ['Com'],
      controller: ['Com', '2'],
      elgin_smart: ['Com'],
    },
    {
      linha: 'ES+',
      productLine: ['ES+'],
      refrigerantFluid: ['R22', 'R404A', 'R134a', 'R448A'],
      compressorType: ['Hermético', 'Scroll', 'Alternativo'],
      compressor: ['Copeland', 'Elgin'],
      logo: ['Elgin'],
      chamber: ['Com'],
      numberOfCompressors: ['1'],
      hotAirDefrost: ['Sem'],
      capacityControl: ['Sem'],
      condensationControl: ['Sem', 'Com'],
      oilSeparator: ['Com', 'Sem'],
      suctionAccumulator: ['Com', 'Sem'],
      suctionFilter: ['Sem', 'Com'],
      contactor: ['Com', 'Sem'],
      liquidServiceValve: ['Sem', 'Com'],
      tankInletValve: ['Com'],
      liquidFilter: ['Com'],
      tank: ['Com'],
      viewfinder: ['Com'],
      insulationinTheSuctionLine: ['Com', 'Sem'],
      suctionServiceValve: ['Com', 'Sem'],
      overloadRelay: ['Sem'],
      circuitBreaker: ['Com', 'Sem'],
      sequenceRelayAndPhaseOutage: ['Sem', 'Com'],
      controller: ['Sem'],
      elgin_smart: ['Sem'],
    },
    {
      linha: 'UCM0',
      productLine: ['UCM0'],
      refrigerantFluid: ['R22'],
      compressorType: ['Alternativo'],
      compressor: ['Elgin', 'Copeland'],
      logo: ['Elgin'],
      chamber: ['Sem'],
      numberOfCompressors: ['1'],
      hotAirDefrost: ['Não'],
      capacityControl: ['Sem'],
      condensationControl: ['Sem'],
      oilSeparator: ['Não'],
      suctionAccumulator: ['Não'],
      suctionFilter: ['Sem'],
      contactor: ['Não'],
      liquidServiceValve: ['Sem'],
      tankInletValve: ['Com'],
      liquidFilter: ['Com'],
      tank: ['Com'],
      viewfinder: ['Com'],
      insulationinTheSuctionLine: ['Sem'],
      suctionServiceValve: ['Não'],
      overloadRelay: ['Não'],
      circuitBreaker: ['Não'],
      sequenceRelayAndPhaseOutage: ['Não'],
      controller: ['Sem'],
      elgin_smart: ['Sem'],
    },
    {
      linha: 'UCMB',
      productLine: ['UCMB'],
      refrigerantFluid: ['R404A', 'R134A', 'R448A'],
      compressorType: ['Alternativo', 'Scroll'],
      compressor: ['Elgin', 'Copeland'],
      logo: ['Elgin'],
      chamber: ['Sem'],
      numberOfCompressors: ['1'],
      hotAirDefrost: ['Não'],
      capacityControl: ['Sem'],
      condensationControl: ['Sem'],
      oilSeparator: ['Não', 'Sim'],
      suctionAccumulator: ['Não', 'Sim'],
      suctionFilter: ['Sem'],
      contactor: ['Não'],
      liquidServiceValve: ['Sem'],
      tankInletValve: ['Com'],
      liquidFilter: ['Com'],
      tank: ['Com'],
      viewfinder: ['Com'],
      insulationinTheSuctionLine: ['Sem'],
      suctionServiceValve: ['Não', 'Sim'],
      overloadRelay: ['Não'],
      circuitBreaker: ['Não'],
      sequenceRelayAndPhaseOutage: ['Não', 'Sim'],
      controller: ['Sem'],
      elgin_smart: ['Sem'],
    },
    {
      linha: 'SLMB',
      productLine: ['SLMB'],
      refrigerantFluid: ['R404A'],
      compressorType: ['Scroll', 'Alternativo'],
      compressor: ['Elgin'],
      logo: ['Elgin'],
      chamber: ['Sem'],
      numberOfCompressors: ['1'],
      hotAirDefrost: ['Sem'],
      capacityControl: ['Sem'],
      condensationControl: ['Sem'],
      oilSeparator: ['Sem'],
      suctionAccumulator: ['Sem'],
      suctionFilter: ['Sem'],
      contactor: ['Sem'],
      liquidServiceValve: ['Sem'],
      tankInletValve: ['Sem', 'Com'],
      liquidFilter: ['Com', 'Sem'],
      tank: ['Sem', 'Com'],
      viewfinder: ['Sem', 'Com'],
      insulationinTheSuctionLine: ['Sem'],
      suctionServiceValve: ['Sem'],
      overloadRelay: ['Sem'],
      circuitBreaker: ['Sem'],
      sequenceRelayAndPhaseOutage: ['Sem'],
      controller: ['Sem'],
      elgin_smart: ['Sem'],
    },
  ];
}

export default EquipmentService;
